import axios from 'axios';
import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { imagePath, urls } from '../Url';
import storage from '../Assets/js/Global';
import moment from 'moment';
import Loader from '../Components/Loader';
import useWhiteLabel from '../Assets/js/useWhiteLabel';
import { jwtDecode } from 'jwt-decode';
import { images } from '../Assets/images';
import { formatBiomarkerName } from '../pages/scanDetails/scanNormalizer';

export const GlobalContext = createContext();
axios.defaults.withCredentials = true;

export const GlobalProvider = ({ children }) => {

    const location = useLocation();
    let loginObject = storage.get('loginObj');
    let deviceInfo = storage.get('device_info');
    const userId = loginObject?.userKey;
    let emailStored = storage.get('verifiedEmail');
    let userModule = storage.get('UserModule');
    const currentPath = location.pathname;
    let companyId = loginObject?.companyKey
    const userEmail = loginObject?.userEmail;
    const isLoggedIn = storage.get('isLoggedIn');
    const licenseType = storage.get('licenseType');
    const refreshTimerRef = useRef(null);
    const is4Life = process.env.REACT_APP_COMPANY_ID === '0it02f';

    const [redirection, setRedirection] = useState({
        productLink: "",
        productShare: ""
    });

    const navigate = useNavigate();
    // Loading state
    const [isLoading, setIsLoading] = useState(false);
    const [msgLoader, setMsgLoader] = useState(false);
    const [isSessionRestoring, setIsSessionRestoring] = useState(false);
    const [timeZone, setTimeZone] = useState([]);
    const [globalUserEmail, setGlobalUserEmail] = useState(userEmail);

    const [showPasswords, setShowPasswords] = useState({
        field1: false,
        field2: false,
    });
    const [userData, setUserData] = useState({
        email: '',
        password: '',
        firstName: '',
        lastName: '',
        otp: '',
        image: '',
        setPassword: '',
        confirmPassword: ''
    });
    const [userDatav2, setUserDatav2] = useState({
        email: '',
        firstName: '',
        lastName: '',
        image: '',
    });

    const [signupData, setSignupData] = useState(() => {
        const saved = storage.get('signupData');
        return saved || {
            firstName: '',
            lastName: '',
            email: '',
            secondaryEmail: '',
            phoneNumber: '',
            accessCode: '',
            age: '',
            weight: '',
            weightUnit: 'kg',
            height: '',
            heightUnit: 'cm',
            race: '',
            gender: '',
            waistCircumference: '',
            waistUnit: 'inch',
            diabetes: '',
            hypertension: '',
            smoking: '',
            country: '',
            time_zone: '',
            wellnessCategory: [],
            fruits: '',
            vegetables: '',
            grains: '',
            sugaryFoods: '',
            redMeat: '',
            fish: '',
            activity: '',
            password: '',
            confirmPassword: ''
        };
    });

    // const verifiedsecEmail = storage.get('verifiedSecondaryEmail');
    const verifiedsecEmail = loginObject?.userSecondaryEmail || storage.get('verifiedSecondaryEmail');
    const [email, setEmail] = useState(() => storage.get('verifiedEmail') || '');
    const [faqList, setFaqList] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [timer, setTimer] = useState(0);
    const [resendDisabled, setResendDisabled] = useState(false);
    const [isThankYou, setIsThankYou] = useState(false);
    const [translatedLabels, setTranslatedLabels] = useState({});
    const [deviceId, setDeviceId] = useState(() => storage.get('DeviceId') || '');
    const [selected, setSelected] = useState(() => storage.get("selectedLanguage") || 'en');
    const [selectedBillType, setSelectedBillype] = useState(() => {
        const saved = storage.get("selectedBillingType");
        return saved ? Number(saved) : null;
    });
    const [userDetails, setUserDetails] = useState({})
    const [servings, setServings] = useState([]);
    const [isVerified, setIsVerified] = useState(false);
    const [logoUrl, setLogoUrl] = useState('');
    const [headerLogoUrl, setHeaderLogoUrl] = useState('');
    const [isManualChange, setIsManualChange] = useState(false);
    const [showOTPSection, setShowOTPSection] = useState(false);
    const [documentData, setDocumentData] = useState({
        file: null,
        previewUrl: "",
        selectedCategory: "",
        documentID: null,
    });
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [documentContent, setDocumentContent] = useState({
        terms: '',
        privacy: '',
    });
    const [articlesList, setArticlesList] = useState([]);
    const [pagination, setPagination] = useState({
        totalRecords: 0,
        totalPages: 1,
        currentPage: 1,
        perPage: 10
    });
    const [search, setSearch] = useState("");
    const prevSearchRef = useRef("");
    const [articleDetails, setArticleDetails] = useState({});
    const [scanDetails, setScanDetails] = useState({});
    const [scanHistory, setScanHistory] = useState({})
    const [wellnessCat, setWellnessCat] = useState([])
    const [bioMarker, setBioMarker] = useState([]);
    const [showExportModal, setShowExportModal] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);
    const calendarRef = useRef(null);
    const [tempScanDetails, setTempScanDetails] = useState();
    const oauthPopupRef = useRef(null);
    const oauthSuccessTokenRef = useRef(null);
    const [historyDates, setHistoryDates] = useState([]);
    const [notification, setNotification] = useState([]);
    const [wellnessLabel, setWellnessLabel] = useState("");
    const [wellnessLabelNormal, setWellnessLabelNormal] = useState("");
    const [hasNotification, setHasNotification] = useState(false);
    const [isPlanActive, setIsPlanActive] = useState(storage.get('isPlanActive') || false);
    const [isNotificationReceived, setIsNotificationReceived] = useState();
    const [notificationsEnabled, setNotificationsEnabled] = useState();
    const [guestList, setGuestList] = useState([]);
    const [fourLifeScanHistory, setFourLifeScanHistory] = useState([]);
    const [scanLimit, setScanLimit] = useState(true);
    const [fourLifeuserData, setFourLifeUserData] = useState({
        userName: "",
        password: "",
    });
    const [products, setProducts] = useState({
        scanId: "",
        top4: [],
        remaining: [],
        shareLink: "https://example.com/recommendations/123",
    });
    const [fullProducts, setFullProducts] = useState({
        scanId: "",
        fullList: []
    })
    const [dynamicTypes, setDynamicTypes] = useState({});

    const prevLangRef = useRef(selected);
    useEffect(() => {
        storage.set("selectedLanguage", selected)
    }, [selected])

    useEffect(() => {
        const handleOAuthMessage = async (event) => {

            const message = event?.data;
            if (!message || typeof message !== 'object') return;
            if (message?.type !== 'OAUTH_SUCCESS') return;
            if (!message?.token) {
                window.showToast?.('error', 'OAuth token missing from popup');
                return;
            }

            const payload = {
                deviceID: deviceId || storage.get('DeviceId'),
                token: message.token,
                companyKey: process.env.REACT_APP_COMPANY_ID
            };

            oauthSuccessTokenRef.current = message.token;

            try {
                const webhookRes = await axios.post(urls.webhookSignup, payload);
                const res = webhookRes?.data;
                if (res?.status === true) {
                    if (res?.msg) {
                        window.showToast('success', res?.msg);
                    }
                    const auth = res?.auth;
                    const next = res?.next;

                    if (auth && typeof auth === "object" && typeof auth.access_token === "string" && auth.access_token.trim() !== "") {
                        const decodeAccessToken = jwtDecode(auth.access_token);
                        storage.set('accessToken', auth.access_token);
                        storage.set('refreshToken', auth.refresh_token);
                        storage.set('tokenExpiry', decodeAccessToken?.exp);
                        storage.set('loginObj', decodeAccessToken);
                        storage.set('isLoggedIn', true);
                        let userId = decodeAccessToken?.userKey;
                        window.ReactNativeWebView?.postMessage(`userID|${userId}`);
                        startTokenRefreshTimer();
                    } else {
                        storage.remove('accessToken');
                        storage.remove('refreshToken');
                        storage.remove('tokenExpiry');
                        storage.remove('loginObj');
                        storage.set('isLoggedIn', false);
                        storage.set('verifiedEmail', res?.email);
                    }

                    if (next === "dashboard") {
                        navigate(is4Life ? '/dashboard2' : '/dashboard');
                        // window.location.href = is4Life ? '/dashboard2' : '/dashboard';
                    } else if (next === "signup") {
                        setEmail(res?.email);
                        storage.set('verifiedEmail', res?.email);
                        updateSignupData("email", res?.email || '');
                        updateSignupData("firstName", res?.first_name || '');
                        updateSignupData("lastName", res?.last_name || '');
                        navigate('/create-account-1');
                    } else {
                        navigate('/login');
                    }

                } else {
                    window.showToast('error', res?.error || "Something went wrong");
                }
            } catch (err) {
                window.showToast('error', err?.response?.data?.error || err.message || 'Webhook signup failed');
            } finally {
                if (oauthPopupRef.current && !oauthPopupRef.current.closed) {
                    oauthPopupRef.current.close();
                }
                oauthPopupRef.current = null;
            }
        };

        window.addEventListener('message', handleOAuthMessage);
        return () => {
            window.removeEventListener('message', handleOAuthMessage);
        };
    }, [deviceId,]);

    const screenLabels = translatedLabels?.common;
    useEffect(() => {
        setWellnessLabel(screenLabels?.avg_reading?.label_value || "Avg. Reading");
        // if (licenseType === "per_user_per_month") {
        // } else if (licenseType === "per_scan_per_month") {
        setWellnessLabelNormal(screenLabels?.normal_reading?.label_value || "Normal Reading");
        // }
    }, [screenLabels]);

    useEffect(() => {
        if (storage.get("isLoggedIn")) {
            storage.remove("signupData");
            storage.remove("signupStep")
            const loginObj = storage.get("loginObj");
            let userId = loginObj?.userKey;
            window.ReactNativeWebView?.postMessage(`userID|${userId}`);
        }
    }, [])

    useEffect(() => {
        function handleClickOutside(event) {
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false);
            }
        }

        if (showCalendar) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showCalendar]);

    const startScan = useCallback(
        async (scanData) => {
            let deviceId = storage.get('DeviceId');
            let loginObject = storage.get('loginObj')
            let userId = loginObject?.userKey;
            let companyId = loginObject?.companyKey;
            if (!deviceId || !scanData || !userId) return;
            let guestUserKey = storage.get("guestUserKey") || null;
            let isGuest = storage.get("scanGuest") || false;
            const payload = {
                deviceID: deviceId,
                userKey: userId,
                companyKey: companyId,
                scanData: scanData,
                guestUserKey: guestUserKey,
                scanType: isGuest ? "guest" : "user",
            };
            await handleApiCall(
                (config) => axios.post(urls.startScan, payload, config),
                (response) => {
                    const res = response.data;
                    if (res.status === true) {
                        window.showToast('success', 'Scan Completed!');
                        if (isGuest) {
                            localStorage.setItem("scanId", res?.data?.scanKey);
                            navigate(is4Life ? '/user-scan-details-four-life' : '/user-scan-details');
                        } else {
                            navigate(is4Life ? '/dashboard2' : '/dashboard');
                        }
                    } else {
                        window.showToast("error", res?.error || "Something went wrong");
                    }
                },
                (error) => {
                    window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
                },
                true
            );
        },
        [navigate]
    );

    useEffect(() => {
        const handler = (event) => {
            try {
                let msg = event?.data;
                let guestScan = storage.get("scanGuest") || false;
                if (typeof msg === "string") {
                    msg = JSON?.parse(msg);
                }
                if (msg && msg?.type === "finalValues") {
                    startScan(msg?.data);
                    setMsgLoader(false);
                } else if (msg?.type === "scanTimeout") {
                    setMsgLoader(false);
                    navigate(!guestScan ? '/start-scan' : '/guest-scan');
                    window.showToast("error", "No face detected for 10 seconds. Please try again.");
                }
                else if (msg?.type === "stopFaceScan") {
                    setMsgLoader(false);
                    navigate(!guestScan ? '/start-scan' : '/guest-scan');
                }
                else if (msg?.type === "cameraPermission") {
                    setMsgLoader(false);
                    navigate(is4Life ? '/dashboard2' : '/dashboard');
                    window.showToast("error", "Please allow camera access to use this feature.");
                }
            } catch (err) {
                console.error("❌ Failed to parse message", err, event?.data);
            } finally {

            }
        };

        document.addEventListener("message", handler);
        window.addEventListener("message", handler);

        return () => {
            document.removeEventListener("message", handler);
            window.removeEventListener("message", handler);
        };
    }, [startScan, navigate]);


    useEffect(() => {
        const handler = (event) => {
            try {
                let msg = event?.data;
                if (typeof msg === "string") {
                    msg = JSON?.parse(msg);
                }

                if (msg?.msg === "licence" && msg?.type) {
                    let message = msg?.type == "per_scan_per_month" ? "user" : "session";
                    storage.set("licenseType", message);
                }

                if (msg?.msg === "notification" && msg?.type === "reminder") {
                    setHasNotification(true);
                }
            } catch (err) {
                console.error("❌ Failed to parse licence message", err, event?.data);
            }
        };

        document.addEventListener("message", handler);
        window.addEventListener("message", handler);

        return () => {
            document.removeEventListener("message", handler);
            window.removeEventListener("message", handler);
        };
    }, []);

    // const handleApiCall = async (
    //     apiCall,
    //     successCallback,
    //     errorCallback,
    //     requiresAuth = true,
    //     options = {}
    // ) => {
    //     const { silent = false } = options;

    //     // if (isSessionRestoring && requiresAuth) {
    //     //     console.warn("API call blocked due to session restoration in progress");
    //     //     return null;
    //     // }

    //     if (!silent) {
    //         setIsLoading(true);
    //     }

    //     try {
    //         const freshToken = storage.get('accessToken');

    //         const config = requiresAuth
    //             ? { headers: { Authorization: `Bearer ${freshToken}` } }
    //             : {};

    //         const response = await apiCall(config);

    //         return successCallback ? successCallback(response) : response;

    //     } catch (error) {
    //         // window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
    //         if (error?.response?.status === 401) {
    //             await getRefreshToken();
    //             return null;
    //         }
    //         const backendError =
    //             error?.response?.data?.error || error?.message || 'Something went wrong';

    //         if (errorCallback) {
    //             errorCallback(error);
    //         } else {
    //             window.showToast('error', backendError);
    //         }

    //         return null;

    //     } finally {
    //         if (!silent) {
    //             setIsLoading(false);
    //         }
    //     }
    // };

    const handleApiCall = async (
        apiCall,
        successCallback,
        errorCallback,
        requiresAuth = true,
        options = {}
    ) => {
        const { silent = false, retry = true } = options;

        if (!silent) setIsLoading(true);

        try {
            const freshToken = storage.get('accessToken');

            const config = requiresAuth
                ? { headers: { Authorization: `Bearer ${freshToken}` } }
                : {};

            const response = await apiCall(config);

            return successCallback ? successCallback(response) : response;

        } catch (error) {

            if (error?.response?.status === 401 && retry) {
                console.log("Token expired → refreshing...");
                await getRefreshToken();
                return handleApiCall(
                    apiCall,
                    successCallback,
                    errorCallback,
                    requiresAuth,
                    { ...options, retry: false }
                );
            }

            const backendError =
                error?.response?.data?.error || error?.message || 'Something went wrong';

            if (errorCallback) {
                errorCallback(error);
            } else {
                window.showToast('error', backendError);
            }

            return null;

        } finally {
            if (!silent) setIsLoading(false);
        }
    };

    const togglePassword = (field) => {
        setShowPasswords((prev) => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const updateUserData = (field, value) => {
        setUserData((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    useEffect(() => {
        setUserData({
            email: '',
            password: '',
            firstName: '',
            lastName: '',
            otp: '',
            image: '',
            setPassword: '',
            confirmPassword: ''
        });
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            const id = storage.get('DeviceId');
            if (id) {
                setDeviceId(id);
                clearInterval(interval);
            }
        }, 100);
        return () => clearInterval(interval);
    }, []);

    function getFontScale() {
        return window.devicePixelRatio || 1;
    }

    function getTimezoneDifference() {
        const offset = new Date().getTimezoneOffset();
        const hours = Math.floor(Math.abs(offset) / 60);
        const minutes = Math.abs(offset) % 60;
        const sign = offset <= 0 ? '+' : '-';
        return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }

    const getDeviceId = useCallback(async () => {
        try {
            const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

            const payload = {
                os: navigator.platform || 'Unknown',
                device_name: navigator.userAgentData?.brands?.[0]?.brand ?? 'Google Chrome',
                system_version: navigator.userAgent,
                font_scale: getFontScale(),
                brand: 'Unknown',
                model: 'Unknown',
                screen_size: `${window.screen.width}x${window.screen.height}`,
                cpu: navigator.hardwareConcurrency || 'Unknown',

                ram: navigator.deviceMemory
                    ? navigator.deviceMemory >= 8
                        ? `${navigator.deviceMemory}+ GB`
                        : `${navigator.deviceMemory} GB`
                    : 'Unknown',

                network_type: connection?.effectiveType || 'Unknown',
                downlink: connection ? `${connection.downlink} Mbps` : 'Unknown',
                network_rtt: connection ? `${connection.rtt} ms` : 'Unknown',
                device_tz: getTimezoneDifference(),
            };
            await handleApiCall(
                () => axios.post(urls.getDeviceId, payload),
                (response) => {
                    if (response.data.status === true) {
                        storage.set('DeviceId', response.data.deviceID);
                    } else {
                        console.error('API Error:', response.data);
                    }
                },
                (error) => {
                    window.showToast('error', error);
                },
                false
            );
        } catch (error) {
            window.showToast('error', error);
        }
    }, []);

    const getCompanyBranding = useCallback(async () => {
        if (!deviceId) return;
        const existingBranding = storage.get("CompanyBranding");

        if (existingBranding) return;

        const payload = {
            deviceID: deviceId,
            companyKey: process.env.REACT_APP_COMPANY_ID
        };

        await handleApiCall(
            (config) => axios.post(urls.getCompanyDetails, payload, { ...config, skipLogoutInterceptor: true }),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    storage.set("CompanyBranding", res.list);
                }
            },
            (error) => window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong'),
            false
        );

    }, [deviceId]);

    const checkUserRegistration = async () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!deviceId) return;
        if (!userData?.email) {
            window.showToast('error', 'Email is required');
            return;
        }

        if (!emailRegex.test(userData?.email)) {
            window.showToast('error', 'Please enter a valid email address');
            return;
        }
        const payload = {
            deviceID: deviceId,
            companyKey: process.env.REACT_APP_COMPANY_ID,
            email: userData?.email?.toLowerCase()
        };

        setEmail(userData?.email);

        await handleApiCall(
            () => axios.post(urls.checkUserRegistration, payload),
            (response) => {
                const res = response?.data;
                if (res?.status === true) {
                    storage.set('UserModule', res.module);
                    storage.set('verifiedEmail', userData?.email);
                    if (res.module === 'Signup') {
                        navigate('/verify-otp');
                    } else if (res.module === 'Login') {
                        navigate('/password')
                    }
                    updateUserData('email', '')
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                    updateUserData('email', '')
                }
            },
            (error) => {
                updateUserData('email', '')
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            false
        );
    };

    const fourLifeSSOLogin = async () => {
        const response = await handleApiCall(
            () => axios.post(urls.ssoLogin, {}),
            (response) => response,
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'SSO login failed');
                return null;
            },
            false
        );

        const res = response?.data;
        if (!res || res.status !== true || !res.url) {
            window.showToast('error', res?.error || 'SSO login failed');
            return;
        }

        const popup = window.open(res.url, 'oauthPopup', 'width=600,height=700,toolbar=0,menubar=0,location=1,resizable=1,scrollbars=1,status=1');
        // if (!popup) {
        //     window.showToast('error', 'Popup blocked. Please allow popups and try again.');
        //     return;
        // }

        // oauthPopupRef.current = popup;
        // storage.set("secret", res.secret || '');

        // const closeWatcher = setInterval(async () => {
        //     if (popup.closed) {
        //         clearInterval(closeWatcher);
        //         oauthPopupRef.current = null;
        //         window.showToast('info', 'SSO window closed.');

        //         const secret = storage.get('secret') || '';
        //         if (!secret) {
        //             window.showToast('error', 'SSO secret token missing after close.');
        //             return;
        //         }

        //         try {
        //             const payload = {
        //                 deviceID: deviceId || storage.get('DeviceId'),
        //                 secret,
        //                 companyKey: process.env.REACT_APP_COMPANY_ID
        //             };
        //             const webhookRes = await axios.post(urls.webhookSignup, payload);
        //             const webhookData = webhookRes?.data;

        //             if (webhookData?.status === true) {
        //                 if (webhookData?.msg) window.showToast('success', webhookData.msg);

        //                 const auth = webhookData.auth;
        //                 const next = webhookData.next;

        //                 if (auth && typeof auth === 'object' && auth.access_token) {
        //                     const decodeAccessToken = jwtDecode(auth.access_token);
        //                     storage.set('accessToken', auth.access_token);
        //                     storage.set('refreshToken', auth.refresh_token);
        //                     storage.set('tokenExpiry', decodeAccessToken?.exp);
        //                     storage.set('loginObj', decodeAccessToken);
        //                     storage.set('isLoggedIn', true);
        //                     window.ReactNativeWebView?.postMessage(`userID|${decodeAccessToken?.userKey}`);
        //                     startTokenRefreshTimer();
        //                 }

        //                 if (next === 'dashboard') {
        //                     window.location.href = is4Life ? '/dashboard2' : '/dashboard';
        //                 } else if (next === 'signup') {
        //                     setEmail(webhookData?.email);
        //                     storage.set('verifiedEmail', webhookData?.email);
        //                     updateSignupData('email', webhookData?.email || '');
        //                     updateSignupData('firstName', webhookData?.first_name || '');
        //                     updateSignupData('lastName', webhookData?.last_name || '');
        //                     navigate('/create-account-1');
        //                 } else {
        //                     window.location.href = '/login';
        //                 }
        //             } else {
        //                 window.showToast('error', webhookData?.error || 'Webhook signup failed after SSO close.');
        //             }
        //         } catch (err) {
        //             window.showToast('error', err?.response?.data?.error || err.message || 'Webhook call on popup close failed.');
        //         }
        //     }
        // }, 500);
    };

    const getuserDetails = async (deviceId, email) => {
        const payload = {
            deviceID: deviceId,
            email: email
        };

        setEmail(email);

        await handleApiCall(
            () => axios.post(urls.getuserDetails, payload),
            (response) => {
                const res = response?.data;
                if (res?.status === true) {
                    setUserDatav2({
                        email: res.userDetails.email || '',
                        firstName: res.userDetails.first_name || '',
                        lastName: res.userDetails.last_name || '',
                        image: res.userDetails.profile_photo || '',
                    });

                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                    updateUserData('email', '')
                }
            },
            (error) => {
                updateUserData('email', '')
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            false
        );
    };

    const loginByPassword = async () => {
        if (!deviceId) return;
        if (!userData?.password) {
            window.showToast('error', 'Password is required');
            return;
        }
        const payload = {
            deviceID: deviceId,
            email: emailStored.toLowerCase(),
            password: userData?.password,
            licence_type: licenseType,
            company_id: process.env.REACT_APP_COMPANY_ID,
            device_data: deviceInfo
        };

        await handleApiCall(
            () => axios.post(urls.userLogin, payload),
            (response) => {
                const res = response?.data;
                if (res?.status === true) {
                    storage.set('isLoggedIn', true)
                    const decodeAccessToken = jwtDecode(res?.token?.access_token);

                    storage.set('accessToken', res?.token?.access_token);
                    storage.set('refreshToken', res?.token?.refresh_token);
                    storage.set('tokenExpiry', decodeAccessToken?.exp);
                    startTokenRefreshTimer();
                    storage.set('loginObj', decodeAccessToken)
                    storage.remove('verifiedEmail');

                    navigate(is4Life ? '/dashboard2' : '/dashboard');
                    storage.set('UserModule', 'Login')
                    let userId = decodeAccessToken?.userKey;
                    window.ReactNativeWebView?.postMessage(`userID|${userId}`);
                    updateUserData('password', '')
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                    updateUserData('password', '')
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
                updateUserData('password', '')
            },
            false
        );
    };

    const sendEmailOTP = async () => {
        if (!deviceId) return;
        if (!email && !loginObject?.userEmail && !emailStored) {
            window.showToast('error', 'Email is required');
            return false;
        }
        const payload = {
            deviceID: deviceId,
            email: email?.toLowerCase() || loginObject?.userEmail?.toLowerCase() || emailStored.toLowerCase(),
            module: userModule,
            companyKey: process.env.REACT_APP_COMPANY_ID,
            role: loginObject?.role || 3
        };
        return await handleApiCall(
            isLoggedIn ? (config) => axios.post(urls.sendEmailOTP, payload, config) : () => axios.post(urls.sendEmailOTP, payload),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    storage.set('verifiedEmail', email);
                    window.showToast('success', res.msg);
                    setShowOTPSection(true)
                    if (currentPath === '/change-password') {
                        navigate('/change-password')
                    } else if (storage.get("isLoggedIn") ? navigate('/deleteAcc-one') : storage.get('UserModule') == 'deleteUser' ? setShowOTPSection(true) : navigate('/verify-otp'))
                        email = '';
                    updateUserData('otp', '');
                    return true;
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                    email = '';
                    updateUserData('otp', '');
                    return false;
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
                email = '';
                return false;
            },
            isLoggedIn ? true : false
        );
    };

    const fourLifeEmailOTP = async ({ email, module }) => {
        if (!deviceId) return;

        if (!email) {
            window.showToast('error', 'Email is required');
            return false;
        }
        const payload = {
            deviceID: deviceId,
            email: email?.toLowerCase(),
            module: module,
            companyKey: process.env.REACT_APP_COMPANY_ID,
            role: loginObject?.role || 3
        };
        return await handleApiCall(
            isLoggedIn ? (config) => axios.post(urls.sendEmailOTP, payload, config) : () => axios.post(urls.sendEmailOTP, payload),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    storage.set('verifiedSecondaryEmail', email);
                    window.showToast('success', res.msg);

                    updateUserData('otp', '');
                    return true;
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                    email = '';
                    updateUserData('otp', '');
                    return false;
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
                email = '';
                return false;
            },
            isLoggedIn ? true : false
        );
    };
    const resendEmailOTP = async () => {
        if (!deviceId) return;
        if (!email && !loginObject?.userEmail && !emailStored) {
            window.showToast('error', 'Email is required');
            return false;
        }
        const payload = {
            deviceID: deviceId,
            email: email?.toLowerCase() || loginObject?.userEmail?.toLowerCase() || emailStored?.toLowerCase(),
            module: userModule,
            role: loginObject?.role || 3
        };

        storage.set('verifiedEmail', email);

        await handleApiCall(
            isLoggedIn ? (config) => axios.post(urls.sendEmailOTP, payload, config) : () => axios.post(urls.sendEmailOTP, payload),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    window.showToast('success', 'OTP Resent successfully.');
                    startResendTimer();
                    updateUserData('otp', '');
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                    updateUserData('otp', '');
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
                updateUserData('otp', '');
            },
            isLoggedIn ? true : false
        );
    };
    const fourLiferesendOTP = async ({ email, module }) => {
        if (!deviceId) return;

        if (!email) {
            window.showToast('error', 'Email is required');
            return false;
        }
        const payload = {
            deviceID: deviceId,
            email: email?.toLowerCase(),
            module: module,
            role: loginObject?.role || 3
        };

        storage.set('verifiedSecondaryEmail', email);

        await handleApiCall(
            isLoggedIn ? (config) => axios.post(urls.sendEmailOTP, payload, config) : () => axios.post(urls.sendEmailOTP, payload),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    window.showToast('success', 'OTP Resent successfully.');
                    startResendTimer();
                    updateUserData('otp', '');
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                    updateUserData('otp', '');
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
                updateUserData('otp', '');
            },
            isLoggedIn ? true : false
        );
    };
    const startResendTimer = () => {
        setTimer(60);
        setResendDisabled(true);
    };

    const handlenavigateToEmail = () => {
        storage.set('UserModule', 'ForgetPassword');
        navigate('/forgot-password');
    };

    const handleChangePassword = () => {
        storage.set('UserModule', 'changePassword');
        navigate('/change-password');
    }

    const handleDeletAccount = () => {
        storage.set('UserModule', 'deleteUser');
        navigate('/deleteAcc-one');
    }
    useEffect(() => {
        let interval;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else {
            setResendDisabled(false);
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [timer]);

    const verifyOTP = async () => {
        if (!deviceId) return;
        if (!userData?.otp) {
            window.showToast('error', 'OTP is required');
            return;
        }
        const payload = {
            deviceID: deviceId,
            email: emailStored || userEmail || email,
            otp: userData?.otp,
            module: userModule,
            role: loginObject?.role || 3,
            companyKey: process.env.REACT_APP_COMPANY_ID
        };

        return await handleApiCall(
            isLoggedIn ? (config) => axios.post(urls.verifyOTP, payload, config) : () => axios.post(urls.verifyOTP, payload),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    setSignupData({});
                    storage.remove('signupData')
                    setIsVerified(true)
                    window.showToast('success', res.msg);
                    if (currentPath === '/change-password') {
                        navigate('/change-password')
                    } else if (storage.get("isLoggedIn") ? navigate('/deleteAcc-one') : storage.get('UserModule') == 'deleteUser' ? setShowOTPSection(false) : navigate('/reset-password'));

                    if (userModule === "Signup") {
                        navigate('/create-account-1');
                    } else {
                        getuserDetails(payload.deviceID, payload.email)
                    }
                    updateUserData('otp', '');
                    return true
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                    updateUserData('otp', '');
                    return false;
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
                updateUserData('otp', '');
                return false;
            },
            isLoggedIn ? true : false
        );
    };

    const fourLifeVerifyOTP = async ({ secondaryemail, module }) => {
        if (!deviceId) return;
        if (!userData?.otp) {
            window.showToast('error', 'OTP is required');
            return;
        }
        const payload = {
            deviceID: deviceId,
            email: secondaryemail,
            otp: userData?.otp,
            module: module,
            role: loginObject?.role || 3,
            companyKey: process.env.REACT_APP_COMPANY_ID
        };

        return await handleApiCall(
            isLoggedIn ? (config) => axios.post(urls.verifyOTP, payload, config) : () => axios.post(urls.verifyOTP, payload),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    setIsVerified(true)
                    window.showToast('success', res.msg);
                    updateUserData("otp", "");
                    return res;

                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                    updateUserData('otp', '');
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
                updateUserData('otp', '');
            },
            isLoggedIn ? true : false
        );
    };

    const resetPassword = async () => {
        if (!deviceId) return;
        if (userData?.setPassword !== userData?.confirmPassword) {
            window.showToast('error', 'Password and confirm password do not match')
            return;
        }
        const payload = {
            deviceID: deviceId,
            password: userData?.setPassword,
            confirm_password: userData?.confirmPassword,
            email: emailStored?.toLowerCase() || userEmail || email,
            module: userModule,
            role: loginObject?.role || 3
        };

        await handleApiCall(
            isLoggedIn ? (config) => axios.post(urls.resetPassword, payload, config) : () => axios.post(urls.resetPassword, payload),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    window.showToast('success', res.msg)
                    navigate('/profile');
                    updateUserData('setPassword', '');
                    updateUserData('confirmPassword', '');
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            isLoggedIn ? true : false
        );
    };
    const isLoggingOutRef = useRef(false);

    const doLogout = useCallback(async (redirect = true) => {
        if (isLoggingOutRef.current) return;
        isLoggingOutRef.current = true;

        let accessToken = storage.get('accessToken');

        try {
            if (refreshTimerRef.current) {
                clearTimeout(refreshTimerRef.current);
                refreshTimerRef.current = null;
            }
            const email = loginObject?.userEmail;

            if (!email || !deviceId || !userId) return;

            const payload = {
                deviceID: deviceId,
                email: email.toLowerCase() || userEmail,
                userID: userId,
                role: 3,
                token: accessToken
            };

            await handleApiCall(
                () => axios.post(urls.doLogout, payload),
                (response) => {
                    const res = response.data;
                    if (res.status === true) {
                        const selectedLanguage = storage.get('selectedLanguage');
                        const translatedLabels = storage.get('appLabels');
                        const isBiometricEnabled = storage.get("biometricAuthEnabled");
                        const deviceData = storage.get("device_info");

                        storage.clear();

                        storage.set('DeviceId', deviceId);
                        storage.set('device_info', deviceData);
                        storage.set('licenseType', licenseType);
                        storage.set('appLabels', translatedLabels);
                        storage.set('selectedLanguage', selectedLanguage);
                        if (isBiometricEnabled !== null && isBiometricEnabled !== undefined) {
                            storage.set('biometricAuthEnabled', isBiometricEnabled);
                        }
                        window?.ReactNativeWebView?.postMessage("googlesignOut");
                        getCompanyBranding();
                        if (redirect) {
                            navigate('/login');
                            // window.location.href = '/login';
                        }
                    } else {
                        window.showToast('error', res.error || 'Something went wrong');
                    }
                },
                (error) => {
                    window.showToast(
                        'error',
                        error?.response?.data?.error || error.message || 'Something went wrong'
                    );
                },
                true
            );
        } finally {
            // Reset after a delay to allow navigation to complete
            setTimeout(() => {
                isLoggingOutRef.current = false;
            }, 3000);
        }
    }, [loginObject?.userEmail, deviceId, userEmail, userId, getCompanyBranding, navigate]);


    const refreshPromiseRef = useRef(null);
    const isRefreshingRef = useRef(false);

    const getRefreshToken = useCallback(async () => {
        if (!deviceId) throw new Error("Device ID missing");

        if (refreshPromiseRef.current) {
            return refreshPromiseRef.current;
        }

        refreshPromiseRef.current = (async () => {
            try {
                const refresh_token = storage.get("refreshToken");

                if (!refresh_token) return;

                const payload = {
                    deviceID: deviceId,
                    refreshToken: refresh_token
                };

                const res = await axios.post(urls.getRefreshToken, payload, {
                    skipLogoutInterceptor: true
                });

                const data = res.data;

                if (!data.status) {
                    throw new Error(data.error || "Refresh failed");
                }
                setIsSessionRestoring(true);
                const accessToken = data?.auth?.access_token;
                const refreshToken = data?.auth?.refresh_token;

                const decoded = jwtDecode(accessToken);

                // ✅ STORE
                storage.set("accessToken", accessToken);
                storage.set("refreshToken", refreshToken);
                storage.set("tokenExpiry", decoded.exp);

                // ✅ UPDATE AXIOS DEFAULT HEADER (IMPORTANT)
                // axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

                return accessToken;

            } catch (err) {
                window.showToast('error', err?.response?.data?.error || err.message || 'Session refresh failed');
                throw err;
            } finally {
                refreshPromiseRef.current = null;
            }
        })();

        return refreshPromiseRef.current;

    }, [deviceId]);

    const startTokenRefreshTimer = useCallback(() => {
        const expiry = storage.get("tokenExpiry");
        if (!expiry) return;

        const now = Math.floor(Date.now() / 1000);
        const timeLeft = expiry - now;

        const refreshTime = Math.max((timeLeft - 30) * 1000, 0);

        if (refreshTimerRef.current) {
            clearTimeout(refreshTimerRef.current);
        }

        refreshTimerRef.current = setTimeout(async () => {
            try {
                await getRefreshToken();
                startTokenRefreshTimer();
            } catch {
                doLogout();
            }
        }, refreshTime);

    }, [getRefreshToken, doLogout]);

    const restoreSession = useCallback(async (isColdStart = false) => {
        if (isRefreshingRef.current) return;

        const accessToken = storage.get('accessToken');
        const refreshToken = storage.get('refreshToken');
        const tokenExpiry = storage.get('tokenExpiry');
        const isLoggedIn = storage.get('isLoggedIn');

        if (!accessToken || !refreshToken || !tokenExpiry || !isLoggedIn) {
            return;
        }

        const currentTime = Math.floor(Date.now() / 1000);
        // Refresh if expired or expiring in less than 30 seconds
        if (currentTime >= (tokenExpiry - 30)) {
            setIsSessionRestoring(true);
            try {
                await getRefreshToken();
                console.log("Token restored successfully");
                startTokenRefreshTimer(); // Ensure timer starts after restoration
            } catch (error) {
                console.error("Session restoration failed:", error);
                doLogout();
            } finally {
                setIsSessionRestoring(false);
            }
        } else if (isColdStart) {
            startTokenRefreshTimer();
        }
    }, [getRefreshToken, doLogout, startTokenRefreshTimer]);

    useEffect(() => {
        const handleAppResume = () => {
            if (document.visibilityState === 'visible') {
                restoreSession();
            }
        };

        // Cold start check
        restoreSession(true);

        document.addEventListener('visibilitychange', handleAppResume);
        return () => {
            document.removeEventListener('visibilitychange', handleAppResume);
        };
    }, [restoreSession]);

    // useEffect(() => {
    //     getScanDetails();
    //     const handleFocus = () => {
    //         console.log("Focus event");
    //         getScanDetails();
    //     };

    //     const handleVisibility = () => {
    //         if (document.visibilityState === "visible") {
    //             console.log("Visibility event");
    //             getScanDetails();
    //         }
    //     };

    //     window.addEventListener("focus", handleFocus);
    //     document.addEventListener("visibilitychange", handleVisibility);

    //     return () => {
    //         window.removeEventListener("focus", handleFocus);
    //         document.removeEventListener("visibilitychange", handleVisibility);
    //     };
    // }, []);

    useEffect(() => {
        if (storage.get('isLoggedIn')) {
            startTokenRefreshTimer();
        }
    }, [startTokenRefreshTimer]);

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            (response) => response,

            async (error) => {
                if (error.config?.skipLogoutInterceptor) {
                    return Promise.reject(error);
                }

                const status = error.response?.status;

                if ((status === 401 || status === 423) && !error.config._retry) {
                    error.config._retry = true;
                    if (status === 423) {
                        storage.clear();
                        window?.ReactNativeWebView?.postMessage("googlesignOut");
                        getDeviceId();
                        getCompanyBranding();
                        navigate('/login');
                        return Promise.reject(error);
                    }

                    try {
                        const token = await getRefreshToken();

                        // ✅ Attach new token
                        error.config.headers["Authorization"] = `Bearer ${token}`;

                        return axios(error.config);

                    } catch (err) {
                        if (!isLoggingOutRef.current) {
                            doLogout();
                        }
                    }
                }

                return Promise.reject(error);
            }
        );

        return () => axios.interceptors.response.eject(interceptor);
    }, [getRefreshToken, doLogout]);

    // axios.interceptors.response.use(
    //     (response) => response,
    //     (error) => {
    //         if (error.config?.skipLogoutInterceptor) return Promise.reject(error);

    //         if ((error.response && error.response.status === 423) || (error.response && error.response.status === 401)) {
    //             setTimeout(() => {
    //                 doLogout();
    //             }, 2000);
    //         }
    //         return Promise.reject(error);
    //     }
    // );



    const updateSignupData = (field, value) => {
        setSignupData(prev => {
            let newData;
            if (typeof field === 'object' && field !== null) {
                // If the first argument is an object, merge it all at once
                newData = { ...prev, ...field };
            } else {
                // Otherwise, treat as single field/value
                newData = { ...prev, [field]: value };
            }

            if (email) newData.email = email;
            storage.set('signupData', newData);
            return newData;
        });
    };

    // Remove the old useEffect hydration as it's now handled in useState
    // (Line 947-955 was the old useEffect)


    const createAccountScreenOne = () => {
        const firstName = signupData.firstName?.trim();
        const lastName = signupData.lastName?.trim();
        const phoneNumber = signupData.phoneNumber?.trim();
        const country = signupData.country?.trim();
        const time_zone = signupData.time_zone?.trim();

        if (!firstName || !lastName || (!is4Life && !phoneNumber) || !country || !time_zone) {
            window.showToast('error', 'Please enter all required fields!');
            return;
        }

        if (signupData.accessCode?.trim() && signupData.accessCode.trim().length > 7) {
            window.showToast('error', 'Access code cannot exceed 7 characters');
            return;
        }
        storage.set('signupStep', 1);
        navigate('/create-account-2');
    };

    const verifyAccessCode = useCallback(async (accessCode) => {
        if (!deviceId) return;
        const userEmail = storage.get('verifiedEmail');
        const payload = {
            deviceID: deviceId,
            accessCode,
            email: signupData?.email || userEmail,
        };

        try {
            const response = await axios.post(urls.accessCodeVerification, payload);
            const res = response.data;

            if (res.status === true) {
                return { status: true };
            } else {
                return { status: false };
            }
        } catch (error) {
            return { status: false };
        }
    }, [deviceId]);

    const createAccountScreenTwo = (providedData) => {
        const dataToValidate = providedData || signupData;
        const { age, weight, height, race, gender, smoking, waistCircumference, diabetes } = dataToValidate;

        if (!age || !weight || !height || !race || !gender || !smoking || !waistCircumference || !diabetes) {
            window.showToast('error', "Please enter all required fields!");
            return;
        }

        if (diabetes === "yes") {
            window.showToast('error', "Please select your diabetes type!");
            return;
        }

        const weightVal = parseFloat(weight);
        const heightVal = parseFloat(height);

        if (isNaN(weightVal) || weightVal <= 0) {
            window.showToast('error', "Weight must be a number greater than 0.");
            return;
        }

        if (isNaN(heightVal) || heightVal <= 0) {
            window.showToast('error', "Height must be a number greater than 0.");
            return;
        }

        const ageVal = parseInt(age);
        const isUnder18 = ageVal < 18;

        if (isUnder18) {
            window.showToast('error', "You must be at least 18 years old to continue.");
            return;
        }

        storage.set('signupStep', 2);
        if (is4Life) {
            navigate('/create-account-3');
        } else {
            navigate('/create-account-v4');
        }
    };

    const createAccountScreenThree = () => {
        const { activity, fruits, vegetables, grains, sugaryFoods, redMeat, fish } = signupData;

        if (!activity || !fruits || !vegetables || !grains || !sugaryFoods || !redMeat || !fish) {
            window.showToast('error', "Please enter all required fields!");
            return;
        }

        storage.set('signupStep', 3);
        navigate('/create-account-5');
    };

    const createAccountScreenFour = () => {
        const { wellnessCategory } = signupData;

        if (!Array.isArray(wellnessCategory) || wellnessCategory.length === 0) {
            window.showToast('error', "Please select your wellness category!");
            return;
        }
        storage.set('signupStep', 4);
        if (is4Life) {
            completeSignup();
        } else {
            navigate('/reset-password');
            storage.set('UserModule', 'setPassword');
        }
    }

    const completeSignup = async () => {
        if (!deviceId) return;
        const requiredFields = [
            'firstName', 'lastName', 'email', 'age', 'weight',
            'height', 'race', 'gender', 'waistCircumference',
            'diabetes', 'wellnessCategory', 'smoking', 'password', 'confirmPassword',
            'fruits', 'vegetables', 'grains', 'sugaryFoods', 'redMeat', 'fish', 'activity', 'time_zone', 'country',
            'phoneNumber', 'accessCode'
        ];

        const isFromQR = !!storage.get('refKey');
        const missingFields = requiredFields.filter(field => {
            // Bypass password for 4Life
            if (is4Life && (field === 'password' || field === 'confirmPassword')) return false;
            // Bypass dietary questions for non-4Life (they skip Step 3 screen)
            if (!is4Life && (field === 'fruits' || field === 'vegetables' || field === 'grains' || field === 'sugaryFoods' || field === 'redMeat' || field === 'fish' || field === 'activity')) return false;
            // Bypass phone number ONLY for 4Life (hidden in UI for them)
            if (is4Life && field === 'phoneNumber') return false;
            // Bypass access code for 4Life OR QR scan users (hidden in UI)
            if ((is4Life || isFromQR) && field === 'accessCode') return false;

            const value = signupData[field];
            if (Array.isArray(value)) return value.length === 0;
            return !value;
        });

        if (missingFields.length > 0) {
            console.warn('[completeSignup] Missing fields:', missingFields, 'signupData:', signupData);
            window.showToast('error', `${is4Life ? 'Please complete all required fields' : 'Please complete all previous steps before setting password'}: ${missingFields.join(', ')}`);
            return;
        }

        if (!is4Life) {
            if (signupData.password !== signupData.confirmPassword) {
                window.showToast('error', 'Password and confirm password do not match');
                return;
            }

            if (!signupData.password || !signupData.confirmPassword) {
                window.showToast('error', 'Please enter password and confirm password');
                return;
            }
        }


        const payload = {
            deviceID: deviceId,
            companyKey: process.env.REACT_APP_COMPANY_ID,
            licence_type: licenseType,
            firstName: signupData.firstName?.trim(),
            lastName: signupData.lastName?.trim(),
            email: signupData.email?.trim().toLowerCase() || email?.trim().toLowerCase(),
            secondaryEmail: signupData?.secondaryEmail?.trim().toLowerCase() || verifiedsecEmail?.trim().toLowerCase(),
            mobileNumber: signupData.phoneNumber || '',
            accessCode: signupData.accessCode || '',
            age: signupData.age,
            weight: signupData.weight,
            weightUnit: signupData.weightUnit,
            height: signupData.height,
            heightUnit: signupData.heightUnit,
            race: signupData.race,
            gender: signupData.gender,

            waistCircumference: signupData.waistCircumference,
            waistUnit: signupData.waistUnit,
            diabetes: signupData.diabetes,
            smoking: signupData.smoking,
            hypertension: signupData.hypertension,
            wellnessCategory: signupData.wellnessCategory || '',

            fruits: signupData.fruits,
            vegetables: signupData.vegetables,
            grains: signupData.grains,
            sugaryFoods: signupData.sugaryFoods,
            redMeat: signupData.redMeat,
            fish: signupData.fish,
            activity: signupData.activity,

            password: signupData.password,
            confirm_password: signupData.confirmPassword,
            token: oauthSuccessTokenRef.current || '',
            time_zone: signupData.time_zone,
            country: signupData.country || '',
            role: loginObject?.role || 3,
            ref_code: storage.get('refKey') || ''
        };

        // console.log(payload);
        // return

        await handleApiCall(
            () => axios.post(urls.completeSignup, payload),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    startTokenRefreshTimer();
                    window.showToast('success', res.msg || 'Account created successfully!');
                    const decodeAccessToken = jwtDecode(res?.token?.access_token);

                    storage.set('accessToken', res?.token?.access_token);
                    storage.set('refreshToken', res?.token?.refresh_token);
                    storage.set('tokenExpiry', decodeAccessToken?.exp);
                    storage.set('loginObj', decodeAccessToken);
                    storage.set('isLoggedIn', true)
                    navigate(is4Life ? '/dashboard2' : '/dashboard');

                    setSignupData({
                        firstName: '',
                        lastName: '',
                        email: '',
                        secondaryEmail: '',
                        phoneNumber: '',
                        accessCode: '',
                        age: '',
                        weight: '',
                        weightUnit: 'lbs',
                        heightUnit: 'feet',
                        waistUnit: 'cm',
                        height: '',
                        race: '',
                        gender: '',
                        waistCircumference: '',
                        diabetes: '',
                        smoking: '',
                        hypertension: '',
                        wellnessCategory: [],
                        fruits: '',
                        vegetables: '',
                        grains: '',
                        sugaryFoods: '',
                        redMeat: '',
                        fish: '',
                        activity: '',
                        country: '',
                        time_zone: '',
                        password: '',
                        confirmPassword: ''
                    });
                    storage.set('UserModule', 'Login');
                    storage.remove('signupData');
                    storage.remove('signupStep');
                    storage.remove('refKey');
                } else {

                    window.showToast('error', res.error || 'Something went wrong');
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            false
        );
    };

    const translateData = useCallback(async (lang) => {
        if (!lang || !deviceId) return;

        const payload = {
            deviceID: deviceId,
            language_code: lang,
            companyKey: process.env.REACT_APP_COMPANY_ID,
            role: loginObject?.role || 3
        };

        await handleApiCall(
            () => axios.post(urls.traslateLabels, payload),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    let labels = res?.translations?.translations_labels?.data;
                    storage.set("appLabels", labels);
                    setTranslatedLabels(labels);
                } else {
                    window.showToast('error', res.msg || 'Something went wrong');
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            false
        );
    }, [deviceId]);

    useEffect(() => {
        const deviceID = storage.get('DeviceId');
        if (!deviceID) {
            getDeviceId();
        }
    }, [getDeviceId]);



    useEffect(() => {
        const seen = storage.get("notificationsSeen");
        if (seen === "true") {
            setIsNotificationReceived(false);
        }
    }, []);

    useEffect(() => {
        if (!userId) return;

        const update = async () => {
            if (!deviceId) return;

            try {
                const token = storage.get("accessToken");
                if (!token) return;
                const payload = {
                    deviceID: deviceId,
                    userKey: userId,
                };

                const response = await axios.post(urls.userLastSeen, payload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const res = response.data;
                if (res.status !== true) {
                    window.showToast("error", res.msg || "Something went wrong");
                } if (res.status === true && res.newNotification) {
                    // only set true when backend reports NEW notifications
                    setIsNotificationReceived(true);
                    storage.set("notificationsSeen", "false");
                }
            } catch (error) {
                window.showToast(
                    "error",
                    error?.response?.data?.error || error.message || "Something went wrong"
                );
            }
        };

        update();
        const interval = setInterval(update, 2 * 60 * 1000);
        return () => clearInterval(interval);
    }, [userId, deviceId]);

    const handleNotificationClick = () => {
        setIsNotificationReceived(false);
        localStorage.setItem("notificationsSeen", "true");
    };

    useEffect(() => {
        const storedLang = storage.get("selectedLanguage");
        const storedLabels = storage.get("appLabels");

        if (storedLang) {
            setSelected(storedLang);
            if (storedLabels) {
                setTranslatedLabels(storedLabels);
            } else {
                translateData(storedLang);
            }
        } else {
            setSelected('en');
            translateData('en');
        }
    }, [translateData]);

    useEffect(() => {
        const storageLabels = storage.get("appLabels")
        if (isManualChange && selected) {
            translateData(selected);
        }
        else {
            setTranslatedLabels(storageLabels)
        }
    }, [selected, isManualChange, translateData]);

    const isEmpty = (value) => {
        return (
            value === null ||
            value === undefined ||
            value === "" ||
            (typeof value === "string" && value.trim() === "") ||
            value === 0
        );
    };

    const getUserDetails = useCallback(async () => {

        if (!deviceId || !userId) return;

        const payload = {
            userKey: userId,
            deviceID: deviceId,
            role: loginObject?.role || 3
        };

        const cacheKey = `cachedUserDetails_${userId}`;
        const cached = storage.get(cacheKey);
        if (cached?.details) {
            setUserDetails(cached.details);
            setServings(cached.servings);
            setNotificationsEnabled(cached.details?.is_fcm_on);
        }

        try {
            const freshToken = storage.get('accessToken');
            const response = await axios.post(urls?.userDetails, payload, {
                headers: freshToken ? { Authorization: `Bearer ${freshToken}` } : {},
            });
            const res = response?.data;
            const details = res?.details;
            const userInfo = {
                userKey: details?.user_key,
                companyKey: details?.company_key,
                firstName: details?.first_name,
                lastName: details?.last_name,
                userEmail: details?.email,
                userSecondaryEmail: details?.secondary_email,
                mobileNumber: details?.mobile_number || null,
                profilePhoto: details?.profile_photo || null,
                role: loginObject?.role || 3,
                deviceID: deviceId || "",
                time_zone: details?.time_zone
            };
            storage.set('loginObj', userInfo);

            if (res?.status === true) {
                const requiredFields = [
                    "gender",
                    "dob",
                    "height",
                    "weight",
                    "waist_circumference",
                    "smoking",
                    "wellness_category",
                    "diabetes",
                    "race",
                ];

                const isProfileIncomplete = requiredFields.some(
                    field => isEmpty(details[field])
                );

                // if (isProfileIncomplete) {
                //     window.showToast("error", "Please complete all required profile fields before starting the scan.");
                //     navigate('/profile-update');
                // }

                setUserDetails(details);
                setServings(res?.servings);
                setNotificationsEnabled(details?.is_fcm_on);
                storage.set(cacheKey, { details, servings: res?.servings });
            } else if (!cached) {
                window.showToast('error', res?.error || 'Something went wrong');
            }
        } catch (err) {
            if (!cached) {
                window.showToast(
                    'error',
                    err?.response?.data?.error || err.message || 'Something went wrong'
                );
            }
        }
    }, [deviceId, userId]);

    const getTimeZone = useCallback(async (search = "") => {
        if (!deviceId) return;

        const url = `${urls?.getTimeZone}?search=${search}`;
        const cacheKey = `cachedTimeZone_${search || 'all'}`;
        const cached = storage.get(cacheKey);
        if (cached) {
            setTimeZone(cached);
        }

        try {
            const freshToken = storage.get('accessToken');
            const response = await axios.get(url, {
                headers: freshToken ? { Authorization: `Bearer ${freshToken}` } : {},
            });
            const res = response?.data;
            if (res?.status === true) {
                setTimeZone(res?.list);
                storage.set(cacheKey, res?.list);
            } else if (!cached) {
                window.showToast('error', res?.error || 'Something went wrong');
            }
        } catch (err) {
            if (!cached) {
                window.showToast(
                    'error',
                    err?.response?.data?.error || err.message || 'Something went wrong'
                );
            }
        }
    }, [deviceId]);


    const updateUserDetails = async (dataToUpdate) => {
        if (!deviceId || !userId) return;
        const { height, weight, waist_circumference } = dataToUpdate
        const heightVal = parseFloat(height);
        const weightVal = parseFloat(weight);
        const waistVal = parseFloat(waist_circumference);

        if (isNaN(heightVal) || heightVal <= 0) {
            window.showToast('error', 'Height must be a number greater than 0.');
            return;
        }

        if (isNaN(weightVal) || weightVal <= 0) {
            window.showToast('error', 'Weight must be a number greater than 0.');
            return;
        }

        if (isNaN(waistVal) || waistVal <= 0) {
            window.showToast('error', 'Waist circumference must be a number greater than 0.');
            return;
        }

        // if (
        //     mobileNumber &&
        //     !isValidPhoneNumber("+" + mobileNumber)
        // ) {
        //     window.showToast("error", "Please enter a valid phone number");
        //     return;
        // }

        // const dobDate = new Date(dob);
        const today = new Date();
        // const age = today.getFullYear() - dobDate.getFullYear();
        // const monthDiff = today.getMonth() - dobDate.getMonth();
        // const dayDiff = today.getDate() - dobDate.getDate();
        // const isUnder18 = age < 18 || (age === 18 && (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)));

        // if (isUnder18) {
        //     window.showToast('error', 'User must be at least 18 years old.');
        //     return;
        // }

        const payload = {
            userID: userId,
            deviceID: deviceId,
            role: loginObject?.role || 3,
            ...dataToUpdate
        };

        return await handleApiCall(
            (config) => axios.post(urls?.updateUserDetails, payload, config),
            (response) => {
                const res = response?.data;
                if (res?.status === true) {
                    window.showToast('success', res.msg || 'User details updated');
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                }
                return res;
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            true
        );
    };

    const deleteUserAcc = async () => {

        // if (!deviceId || !email) return;
        if (!deviceId || (is4Life ? !verifiedsecEmail : !email)) return;

        const payload = {
            // email: email,
            email: is4Life ? verifiedsecEmail : email,
            deviceID: deviceId,
            companyKey: process.env.REACT_APP_COMPANY_ID,
        };

        return await handleApiCall(
            (config) => axios.post(urls?.deleteUserAcc, payload, config),
            (response) => {
                const res = response?.data;
                if (res?.status === true) {
                    window.showToast('success', res.msg || 'User Deleted');
                    if (storage.get('isLoggedIn') == true) {
                        // navigate('/login');
                        storage.clear();
                        window?.ReactNativeWebView?.postMessage("googlesignOut");
                        getDeviceId();
                        getCompanyBranding();
                        navigate('/login');
                    } else {
                        setIsThankYou(true);
                    }

                    // storage.remove('loginObj');
                    // storage.remove('verifiedEmail');
                    // storage.remove('UserModule');
                    // storage.remove('verifiedSecondaryEmail');

                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                }
                return res;
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            true
        );
    }


    const getFaqList = useCallback(async () => {
        if (!companyId || !deviceId || !userId) return;
        const payload = {
            deviceID: deviceId,
            companyKey: companyId,
            faq_id: '',
            adminKey: '',
            role: loginObject?.role || 3,
            userKey: userId
        };

        await handleApiCall(
            (config) => axios.post(urls.getFaqList, payload, config),
            (response) => {
                const res = response?.data;
                if (res?.status === true) {
                    setFaqList(res?.faq)
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            true
        );
    }, [companyId, deviceId, userId]);

    const uploadCropImg = async (blob) => {
        if (!userId) return;
        const formData = new FormData();
        formData.append("userID", userId);
        formData.append("image", blob, "profile.jpg");
        formData.append("slug", "user_profile");
        formData.append("role", loginObject?.role || 3);

        await handleApiCall(
            (config) =>
                axios.post(urls.uploadCroppedImg, formData, {
                    ...config,
                    headers: { "Content-Type": "multipart/form-data" },
                }),
            async (response) => {
                const res = response?.data;
                if (res?.status === true) {
                    window.showToast("success", "Profile image updated!");
                    await getUserDetails();
                } else {
                    window.showToast("error", res.error || "Something went wrong");
                }
            },
            (error) => {
                console.error(error);
                window.showToast(
                    "error",
                    error?.response?.data?.error ||
                    error.message ||
                    "Something went wrong"
                );
            },
            true
        );
    };



    const getLanguageList = useCallback(async () => {
        if (!deviceId) return;
        const payload = {
            deviceID: deviceId,
            companyKey: process.env.REACT_APP_COMPANY_ID,
        };

        const cacheKey = `cachedLanguageList`;
        const cached = storage.get(cacheKey);
        if (cached) {
            setLanguages(cached);
        }

        try {
            const response = await axios.post(urls?.getLanguage, payload);
            const res = response?.data;
            if (res?.status === true) {
                setLanguages(res?.list);
                storage.set(cacheKey, res?.list);
            } else if (!cached) {
                window.showToast('error', res?.error || 'Something went wrong');
            }
            return res;
        } catch (err) {
            if (!cached) {
                window.showToast(
                    'error',
                    err?.response?.data?.error || err.message || 'Something went wrong'
                );
            }
        }
    }, [deviceId])

    useEffect(() => {
        getCompanyBranding();
    }, [getCompanyBranding]);

    const whiteLabel = useWhiteLabel();

    useEffect(() => {
        if (whiteLabel) {
            const root = document.documentElement;
            root.style.setProperty('--primaryColor', whiteLabel.primary_color || '');
            root.style.setProperty('--secondaryColor', whiteLabel.secondary_color || '');
            root.style.setProperty('--textColor', whiteLabel.text_color || '');
            root.style.setProperty('--headingColor', whiteLabel.heading_color || '');
            root.style.setProperty('--buttonColor', whiteLabel.button_color || '');
            root.style.setProperty('--buttonHoverColor', whiteLabel.button_color_hover || '');
            root.style.setProperty('--buttonTxtColor', whiteLabel.button_text_color || '');
            root.style.setProperty('--buttonTxtHoverColor', whiteLabel.button_text_color_hover || '');
            root.style.setProperty('--darkcolor', whiteLabel.text_color || '');

            root.style.setProperty('--headerBgColor', whiteLabel.header_background_color || '');
            root.style.setProperty('--headerTextColor', whiteLabel.header_text_color || '');
            root.style.setProperty('--footerBgColor', whiteLabel.footer_background_color || '');
            root.style.setProperty('--footerTextColor', whiteLabel.footer_text_color || '');
            root.style.setProperty('--footerIconColor', whiteLabel.footer_icon_color || '');
            root.style.setProperty('--footerMenuActiveColor', whiteLabel.footer_menu_active_color || '');
            root.style.setProperty('--sidebarBgColor', whiteLabel.sidebar_color || '');
            root.style.setProperty('--sidebarTextColor', whiteLabel.sidebar_text_color || '');
            root.style.setProperty('--sidebarIconColor', whiteLabel.sidebar_icon_color || '');
            root.style.setProperty('--sidebarActiveMenuColor', whiteLabel.sidebar_menu_active_color || '');
            root.style.setProperty('--pageBgColor', whiteLabel.page_background_color || '');
            root.style.setProperty('--linkColor', whiteLabel.link_color || '');

            const baseUrl = imagePath;
            const companyLogoUrl = whiteLabel?.company_logo ? baseUrl + whiteLabel.company_logo : '';
            const appHeaderLogoUrl = whiteLabel?.app_header_logo ? baseUrl + whiteLabel.app_header_logo : '';
            setLogoUrl(companyLogoUrl);
            setHeaderLogoUrl(appHeaderLogoUrl || companyLogoUrl);
        }
    }, [whiteLabel]);

    const uploadDocument = async () => {
        if (!deviceId || !userId || !companyId) return;
        const { file, selectedCategory, documentID } = documentData;

        if (!file || !selectedCategory || selectedCategory === 'all') {
            window.showToast("error", "Both category and file are required.");
            return;
        }

        const formData = new FormData();
        formData.append("companyID", companyId);
        formData.append("deviceID", deviceId);
        formData.append("userId", userId);
        formData.append("category", selectedCategory);
        formData.append("document", file);

        if (documentID) {
            formData.append("documentID", documentID);
        }

        await handleApiCall(
            (config) => axios.post(urls.uploadDocument, formData, {
                ...config,
                headers: {
                    ...config.headers,
                    'Content-Type': 'multipart/form-data',
                }
            }),
            (response) => {
                const res = response?.data;
                if (res?.status === true) {
                    window.showToast("success", res.msg || (documentID ? "Updated successfully" : "Uploaded successfully"));
                    setDocumentData({
                        file: null,
                        previewUrl: "",
                        selectedCategory: "",
                        documentID: null,
                    });
                    storage.remove("documentUpdate")
                    navigate('/documents');
                } else {
                    window.showToast("error", res?.error || (documentID ? "Update failed" : "Upload failed"));
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            true
        );
    };

    const getDocumentList = useCallback(async () => {
        if (!deviceId || !userId || !companyId) return;

        const payload = {
            deviceID: deviceId,
            userKey: userId,
            role: loginObject?.role || 3,
            adminKey: '',
            category: '',
            companyKey: companyId
        };

        await handleApiCall(
            (config) => axios.post(urls.getDocumentList, payload, config),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    const formatted = res?.documents?.map((item) => {
                        const [date, time] = item.created_at.split(" ");
                        const [y, m, d] = date.split("-");
                        const isPM = +time.split(":")[0] >= 12;
                        const hour = (+time.split(":")[0] % 12) || 12;
                        const formattedTime = `${hour}:${time.split(":")[1]} ${isPM ? "PM" : "AM"}`;

                        return {
                            id: item.id,
                            key: item.category,
                            fileName: item.file_name,
                            date: `${d}/${m}/${y}`,
                            time: formattedTime,
                            fullPath: item.file_name,
                            userName: item.user_name,
                            status: item.status,
                            file_size: item.file_size
                        };
                    });

                    setUploadedFiles(formatted);
                } else {
                    window.showToast("error", res?.error || "Upload failed");
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            true
        );
    }, [deviceId, userId, companyId]);

    const deletedocument = useCallback(async (documentId) => {

        if (!deviceId || !documentId || !userId) return;

        const payload = {
            deviceID: deviceId,
            userKey: userId,
            documentID: documentId,
            role: loginObject?.role || 3
        };

        await handleApiCall(
            (config) => axios.post(urls.deleteDocument, payload, config),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    window.showToast('success', res.msg);
                    setUploadedFiles(prevFiles => prevFiles.filter(doc => doc.id !== documentId));
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                }
            },
            (error) => {
                window.showToast(
                    'error',
                    error?.response?.data?.error || error.message || 'Something went wrong'
                );
            },
            true
        );
    }, [deviceId, userId]);

    const getTermsConditions = useCallback(async () => {
        if (!deviceId || !companyId) return;

        const payload = {
            deviceID: deviceId,
            role: loginObject?.role || 3,
            companyKey: companyId,
            adminKey: '',
        };

        const cacheKey = `cachedTermsConditions`;
        const cached = storage.get(cacheKey);
        if (cached) {
            setDocumentContent(prev => ({ ...prev, terms: cached }));
        }

        try {
            const freshToken = storage.get('accessToken');
            const response = await axios.post(urls.getTermsConditions, payload, {
                headers: freshToken ? { Authorization: `Bearer ${freshToken}` } : {},
            });
            const res = response?.data;
            if (res?.status === true) {
                const terms = res?.details?.terms_conditions || '';
                setDocumentContent(prev => ({ ...prev, terms }));
                storage.set(cacheKey, terms);
            } else if (!cached) {
                window.showToast("error", res?.error || "Something went wrong");
            }
        } catch (err) {
            if (!cached) {
                window.showToast(
                    'error',
                    err?.response?.data?.error || err.message || 'Something went wrong'
                );
            }
        }
    }, [deviceId, companyId]);


    const getPrivacypolicy = useCallback(async () => {
        if (!deviceId || !companyId) return;

        const payload = {
            deviceID: deviceId,
            role: loginObject?.role || 3,
            companyKey: companyId,
            adminKey: '',
        };

        const cacheKey = `cachedPrivacyPolicy`;
        const cached = storage.get(cacheKey);
        if (cached) {
            setDocumentContent(prev => ({ ...prev, privacy: cached }));
        }

        try {
            const freshToken = storage.get('accessToken');
            const response = await axios.post(urls.getPrivacypolicy, payload, {
                headers: freshToken ? { Authorization: `Bearer ${freshToken}` } : {},
            });
            const res = response?.data;
            if (res?.status === true) {
                const privacy = res?.details?.privacy_policy || '';
                setDocumentContent(prev => ({ ...prev, privacy }));
                storage.set(cacheKey, privacy);
            } else if (!cached) {
                window.showToast("error", res?.error || "Something went wrong");
            }
        } catch (err) {
            if (!cached) {
                window.showToast(
                    'error',
                    err?.response?.data?.error || err.message || 'Something went wrong'
                );
            }
        }
    }, [deviceId, companyId]);

    const getArticlesList = useCallback(async (page = 1, perPage = 10) => {
        if (!deviceId || !companyId || !userId || !selected) return;

        if (prevLangRef.current !== selected || prevSearchRef.current !== search) {
            page = 1;
            prevLangRef.current = selected;
            prevSearchRef.current = search;
        }

        const payload = {
            deviceID: deviceId,
            role: loginObject?.role || 3,
            companyKey: process.env.REACT_APP_COMPANY_ID,
            userKey: userId,
            languageCode: selected,
            page: page,
            search: search
        };

        try {
            const freshToken = storage.get("accessToken");
            const config = {
                headers: { Authorization: `Bearer ${freshToken}` }
            };

            const response = await axios.post(urls.getArticlesList, payload, config);
            const res = response.data;

            if (res.status === true) {
                const articleData = res?.article;
                setArticlesList(articleData?.data || []);
                setPagination({
                    totalRecords: articleData?.total_records || 0,
                    totalPages: articleData?.total_pages || 1,
                    currentPage: page,
                    perPage: articleData?.per_page || perPage
                });
            } else {
                window.showToast("error", res?.error || "Something went wrong");
            }
        } catch (error) {
            window.showToast(
                "error",
                error?.response?.data?.error || error.message || "Something went wrong"
            );
        }
    }, [deviceId, companyId, userId, selected, search]);


    const resetArticlesSearch = useCallback(() => {
        setSearch("");
        prevSearchRef.current = "";
        prevLangRef.current = selected;
    }, [selected]);

    const getArticleDetailsByID = useCallback(
        async (article_id) => {
            if (!deviceId || !companyId || !userId || !article_id) return;

            const payload = {
                deviceID: deviceId,
                role: loginObject?.role || 3,
                companyKey: companyId,
                userKey: userId,
                article_id: article_id,
            };

            setArticleDetails({});

            await handleApiCall(
                (config) => axios.post(urls.getArticldetailsById, payload, config),
                (response) => {
                    const res = response.data;
                    if (res.status === true) {
                        setArticleDetails(res.article);
                    } else {
                        window.showToast("error", res?.error || "Something went wrong");
                    }
                },
                (error) => {
                    window.showToast(
                        "error",
                        error?.response?.data?.error || error.message || "Something went wrong"
                    );
                },
                true
            );
        },
        [deviceId, companyId, userId]
    );

    const normalizePercent = (val) => {
        if (val === null || val === undefined || isNaN(val)) return null;
        return Math.min(100, Math.max(0, Number(val)));
    };

    const mapBiomarkers = (factors = {}, screenLabels, parentColor) => {
        return Object.entries(factors)
            .map(([key, val]) => {
                const percent = normalizePercent(val?.percent);
                const minPercent = normalizePercent(val?.min_percent);
                const maxPercent = normalizePercent(val?.max_percent);
                const avgValue = val?.avg_value ?? null;
                const normalValue = val?.normal_value ?? null;
                const unit = val?.unit || "";
                const value = val?.val ?? null;

                if (!percent || percent === 0) return null;

                if (minPercent === null || maxPercent === null) return null;

                return {
                    name: formatBiomarkerName(key, screenLabels),
                    rawKey: key,
                    percent,
                    minPercent,
                    maxPercent,
                    normalValue,
                    avgValue,
                    unit,
                    value,
                    shadowColor: parentColor,
                };
            })
            .filter(Boolean);
    };

    const applyScanResponse = useCallback((res) => {
        if (res?.is_active == false) {
            storage.set('isPlanActive', false)
        } else {
            storage.set('isPlanActive', true)
        }

        const vendorUserKey = res?.venderDetails?.vender_user_key;
        const vendorProjectKey = res?.venderDetails?.vender_project_key;
        storage.set('chatVendorUserKey', vendorUserKey);
        storage.set('chatVendorProjectKey', vendorProjectKey);
        const scanData = res?.scanList?.scan_data;
        const recommendations = res?.scanList?.recommendation || [];
        const biomarkerScore = res?.scanList?.biomarker_score;

        const dynamicTypes = {
            cardiovascular: {
                label: screenLabels?.cardiovascular?.label_value || "Cardiovascular",
                color: biomarkerScore?.cv_color,
                score: Number(biomarkerScore?.cv_score || 0),
                biomarkers: mapBiomarkers(biomarkerScore?.cv_factors, screenLabels, biomarkerScore?.cv_color),
            },
            immune: {
                label: screenLabels?.immune?.label_value || "Immune",
                color: biomarkerScore?.immune_color,
                score: Number(biomarkerScore?.immune_score || 0),
                biomarkers: mapBiomarkers(biomarkerScore?.immune_factors, screenLabels, biomarkerScore?.metabolic_color),
            },
            metabolic: {
                label: screenLabels?.metabolic?.label_value || "Metabolic",
                color: biomarkerScore?.metabolic_color,
                score: Number(biomarkerScore?.metabolic_score || 0),
                biomarkers: mapBiomarkers(biomarkerScore?.metabolic_factors, screenLabels, biomarkerScore?.metabolic_color),
            },
            stress: {
                label: screenLabels?.stress?.label_value || "Stress",
                color: biomarkerScore?.stress_color,
                score: Number(biomarkerScore?.stress_score || 0),
                biomarkers: mapBiomarkers(biomarkerScore?.stress_factors, screenLabels, biomarkerScore?.stress_color),
            },
            sugar: {
                label: screenLabels?.sugar?.label_value || "Sugar",
                color: biomarkerScore?.sugar_color,
                score: Number(biomarkerScore?.sugar_score || 0),
                biomarkers: mapBiomarkers(biomarkerScore?.sugar_factors, screenLabels, biomarkerScore?.sugar_color),
            },
        };
        const cleanedDynamicTypes = Object.fromEntries(
            Object.entries(dynamicTypes).filter(
                ([_, type]) => type.biomarkers.length > 0
            )
        );

        setDynamicTypes(cleanedDynamicTypes);
        setScanDetails(scanData);
        setTempScanDetails(scanData);
        setRedirection({
            productLink: res?.scanList?.product_link,
            productShare: res?.scanList?.product_share
        });

        const formattedProducts = recommendations.map((item, index) => ({
            id: item.item_id || index,
            name: item.short_desc,
            image: item?.image !== null ? item?.image : images.placeHolderImg,
            description: item.reasons?.length
                ? `Helps with ${item.reasons.slice(0, 3).map(r => r.name).join(" & ")}`
                : "Recommended for you",
        }));
        setProducts({
            scanId: res?.scanList?.scanID,
            top4: formattedProducts.slice(0, 4),
            remaining: formattedProducts.slice(4),
            shareLink: "https://example.com/recommendations/123",
            date: res?.scanList?.converted_time,
        });
    }, [screenLabels]);

    const getScanDetails = useCallback(
        async (scanID = "") => {
            let deviceId = storage.get("DeviceId");

            if (!deviceId || !userId || !companyId) return;

            const cacheKey = `cachedScanResponse_${userId}_${scanID || 'latest'}`;
            const cached = storage.get(cacheKey);

            if (cached) {
                applyScanResponse(cached);
            }

            const payload = {
                deviceID: deviceId,
                role: loginObject?.role || 3,
                userKey: userId,
                scanID: scanID,
                adminKey: "",
                licence_type: licenseType,
                companyKey: companyId
            };

            try {
                const freshToken = storage.get('accessToken');
                const response = await axios.post(urls.getScanDetails, payload, {
                    headers: freshToken ? { Authorization: `Bearer ${freshToken}` } : {},
                });
                const res = response?.data;
                if (res?.status === true) {
                    applyScanResponse(res);
                    storage.set(cacheKey, res);
                } else if (!cached) {
                    window.showToast("error", res?.error || "Something went wrong");
                }
            } catch (err) {
                if (!cached) {
                    window.showToast(
                        "error",
                        err?.response?.data?.error || err.message || "Something went wrong"
                    );
                }
            }
        },
        [deviceId, companyId, userId, applyScanResponse]
    );

    const getRecProductList = useCallback(
        async (scanID = "") => {
            if (!deviceId || !companyId || !userId) return;

            const payload = {
                deviceID: deviceId,
                userKey: userId,
                scanID: scanID,
                role: loginObject?.role || 3,
            };

            await handleApiCall(
                (config) => axios.post(urls.recProductList, payload, config),
                (response) => {
                    const res = response.data;
                    if (res.status === true) {
                        setFullProducts({
                            scanId: scanID,
                            fullList: res?.list || [],
                        });
                    } else {
                        window.showToast("error", res?.error || "Something went wrong");
                    }
                },
                (error) => {
                    window.showToast(
                        "error",
                        error?.response?.data?.error || error.message || "Something went wrong"
                    );
                },
                true
            );
        },
        [deviceId, companyId, userId]
    );
    const getScanHistory = useCallback(
        async (date) => {
            if (!deviceId || !companyId || !userId) return;

            const payload = {
                deviceID: deviceId,
                userKey: userId,
                companyKey: companyId,
                date: date,
            };

            await handleApiCall(
                (config) => axios.post(urls.getScanHistory, payload, config),
                (response) => {
                    const res = response.data;
                    if (res.status === true) {
                        setScanHistory(res);
                    } else {
                        window.showToast("error", res?.error || "Something went wrong");
                    }
                },
                (error) => {
                    window.showToast(
                        "error",
                        error?.response?.data?.error || error.message || "Something went wrong"
                    );
                },
                true
            );
        },
        [deviceId, companyId, userId]
    );
    const getWellnessCat = useCallback(async () => {
        if (!deviceId) return;

        const payload = {
            deviceID: deviceId,
        };

        const cacheKey = `cachedWellnessCat`;
        const cached = storage.get(cacheKey);
        if (cached) {
            setWellnessCat(cached);
        }

        try {
            const response = await axios.post(urls.listWellnessCat, payload);
            const res = response?.data;
            if (res?.status === true) {
                const data = res?.translations || res?.list;
                setWellnessCat(data);
                storage.set(cacheKey, data);
            } else if (!cached) {
                window.showToast("error", res?.error || "Something went wrong");
            }
        } catch (err) {
            if (!cached) {
                window.showToast(
                    'error',
                    err?.response?.data?.error || err.message || 'Something went wrong'
                );
            }
        }
    }, [deviceId]);

    const listBioMarker = useCallback(async () => {
        if (!deviceId || !selected) return;

        const payload = {
            deviceID: deviceId,
            languageCode: selected,
            companyKey: process.env.REACT_APP_COMPANY_ID,
            role: loginObject?.role || 3
        };

        const cacheKey = `cachedBioMarker_${selected}`;
        const cached = storage.get(cacheKey);
        if (cached) {
            setBioMarker(cached);
        }

        try {
            const freshToken = storage.get('accessToken');
            const response = await axios.post(urls.listBioMarker, payload, {
                headers: freshToken ? { Authorization: `Bearer ${freshToken}` } : {},
            });
            const res = response?.data;
            if (res?.status === true) {
                const data = res?.list || res?.translations?.translations_labels?.data;
                setBioMarker(data);
                storage.set(cacheKey, data);
            } else if (!cached) {
                window.showToast("error", res?.error || "Something went wrong");
            }
        } catch (err) {
            if (!cached) {
                window.showToast(
                    "error",
                    err?.response?.data?.error || err.message || "Something went wrong"
                );
            }
        }
    }, [deviceId, selected]);

    const editUserDetails = useCallback(
        async (details) => {
            if (!deviceId || !userId || !companyId) return;

            // let age = "";
            // if (details.dob) {
            //     const today = new Date();
            //     const dob = new Date(details.dob);
            //     age = today.getFullYear() - dob.getFullYear();
            //     const m = today.getMonth() - dob.getMonth();
            //     if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
            //         age--;
            //     }
            // }

            if (!details.age || details.age < 18) {
                window.showToast("error", "Please enter a valid age (18 or above).");
                setMsgLoader(false);
                return;
            }
            let translatedLabels = storage.get('appLabels');


            const labels = {
                // Existing keys                                                                                                               
                pulse_wait: translatedLabels?.common?.pulse_wait,
                no_detect_face: translatedLabels?.common?.no_detect_face,
                no_detect_face_note: translatedLabels?.common?.no_detect_face_note,
                face_detect: translatedLabels?.common?.face_detect,
                scan_comment: translatedLabels?.common?.scan_comment,
                stop: translatedLabels?.common?.stop,
                adjust_face: translatedLabels?.common?.adjust_face,
                scan_stopped_note: translatedLabels?.common?.scan_stopped_note,
                scan_stopped: translatedLabels?.common?.scan_stopped,

                // Top Bar
                app_title: translatedLabels?.common?.app_title,
                front_camera_capture: translatedLabels?.common?.front_camera_capture,
                back_camera_capture: translatedLabels?.common?.back_camera_capture,

                // Oval Label
                position_face: translatedLabels?.common?.position_face,
                locking: translatedLabels?.common?.locking,
                hold_still: translatedLabels?.common?.hold_still,

                // Bottom Status Card
                readiness: translatedLabels?.common?.readiness,
                searching_for_face: translatedLabels?.common?.searching_for_face,
                stabilizing_frame: translatedLabels?.common?.stabilizing_frame,
                motion_detected: translatedLabels?.common?.motion_detected,
                capturing_signal: translatedLabels?.common?.capturing_signal,
                ready_to_begin: translatedLabels?.common?.ready_to_begin,
                locked: translatedLabels?.common?.locked,
                align: translatedLabels?.common?.align,

                // Progress
                of: translatedLabels?.common?.of,
                ready_to_scan: translatedLabels?.common?.ready_to_scan,

                // Buttons
                start_scan: translatedLabels?.common?.start_scan,
                hold_still_btn: translatedLabels?.common?.hold_still_btn,
                locking_face: translatedLabels?.common?.locking_face,
                look_at_camera: translatedLabels?.common?.look_at_camera,

                // Status Messages
                low_light: translatedLabels?.common?.low_light,
                too_bright: translatedLabels?.common?.too_bright,
                move_back: translatedLabels?.common?.move_back,
                move_closer: translatedLabels?.common?.move_closer,
                center_face: translatedLabels?.common?.center_face,
                look_at_camera_msg: translatedLabels?.common?.look_at_camera_msg,
                hold_still_lock: translatedLabels?.common?.hold_still_lock,
                hold_still_msg: translatedLabels?.common?.hold_still_msg,
                face_locked_start: translatedLabels?.common?.face_locked_start,
                hold_phone_eye_level: translatedLabels?.common?.hold_phone_eye_level,

                // Processing Overlay
                generating_health_report: translatedLabels?.common?.generating_health_report,
                analysing_vitals: translatedLabels?.common?.analysing_vitals,

                // Camera Permission Screen
                camera_scan_title: translatedLabels?.common?.camera_scan_title,
                camera_access_needed: translatedLabels?.common?.camera_access_needed,
                camera_permission_text: translatedLabels?.common?.camera_permission_text,
                allow_camera_access: translatedLabels?.common?.allow_camera_access,
                no_camera_device: translatedLabels?.common?.no_camera_device,
            };

            const payload = {
                deviceID: deviceId,
                userKey: userId,
                companyKey: companyId,
                role: loginObject?.role || 3,
                gender: details.gender,
                diabetes: details.diabetes,
                weightUnit: details.weightUnit,
                weight: details.weight,
                heightUnit: details.heightUnit,
                height: details.height,
                smoking: details.smoking,
                dob: details.dob,
                age: details.age,
                race: details.race,
                cameraMode: details.cameraMode,
                labels: labels,
                language: storage.get('selectedLanguage') || 'en'
            };

            await handleApiCall(
                (config) => axios.post(urls.updateUserData, payload, config),
                (response) => {
                    const res = response.data;
                    if (res.status === true) {
                        storage.set('loginObj', res?.data);
                        let isPlanActive = storage.get('isPlanActive');
                        if (isPlanActive == true) {
                            console.log("=== StartScan Payload ===");
                            console.log("Full Payload:", payload);
                            console.log("Camera Mode:", payload.cameraMode);
                            console.log("Race:", payload.race);
                            console.log("Gender:", payload.gender);
                            console.log("Age:", payload.age);
                            console.log("=======================");
                            window.ReactNativeWebView?.postMessage(`startScan|${JSON.stringify(payload)}`);
                        } else {
                            setMsgLoader(false);
                            navigate('/plan-expired');
                        }
                    } else {
                        window.showToast("error", res?.error || "Something went wrong");
                    }
                }
            );
        },
        [deviceId, userId, companyId, isPlanActive]
    );

    useEffect(() => {
        const disableContextMenu = (e) => e.preventDefault();
        const disableCopy = (e) => e.preventDefault();
        const disableSelection = (e) => e.preventDefault();

        document.addEventListener("contextmenu", disableContextMenu);
        document.addEventListener("copy", disableCopy);
        document.addEventListener("selectstart", disableSelection);

        return () => {
            document.removeEventListener("contextmenu", disableContextMenu);
            document.removeEventListener("copy", disableCopy);
            document.removeEventListener("selectstart", disableSelection);
        };
    }, []);


    const exportScanDetails = useCallback(
        async (email, scanID, documentID, module) => {
            if (!deviceId || !userId || !email || (module !== "Document" && !scanID)) return;
            const storedLang = storage.get("selectedLanguage");
            const payload = {
                deviceID: deviceId,
                userKey: userId,
                companyKey: process.env.REACT_APP_COMPANY_ID,
                email,
                scanID,
                documentID,
                module,
                languageCode: storedLang
            };

            try {
                const response = await handleApiCall(
                    (config) => axios.post(urls.exportUserScanDetails, payload, config),
                    (response) => response.data
                );

                const res = response?.data || response;
                if (res?.status === true) {
                    window.showToast("success", res.message);
                    navigate(is4Life ? '/dashboard2' : '/dashboard');
                    return true;
                } else {
                    window.showToast("error", res?.error || "Something went wrong");
                    return false;
                }
            } catch (err) {
                window.showToast("error", "Export failed");
                return false;
            }
        },
        [deviceId, userId]
    );

    const getHistoryDates = useCallback(async () => {
        if (!deviceId || !userId) return;

        const payload = {
            deviceID: deviceId,
            userKey: userId,
            companyKey: process.env.REACT_APP_COMPANY_ID,
            role: loginObject?.role || 3
        };
        await handleApiCall(
            (config) => axios.post(urls.getHistoryDates, payload, config),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    setHistoryDates(res?.list || [])
                } else {
                    window.showToast("error", res?.error || "Something went wrong");
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            true
        );
    }, [deviceId, userId]);


    const getNotificationList = useCallback(async () => {
        if (!deviceId || !userId) return;

        const payload = {
            deviceID: deviceId,
            userKey: userId,
            companyKey: companyId,
            role: loginObject?.role || 3
        };
        await handleApiCall(
            (config) => axios.post(urls.getNotificationList, payload, config),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    setNotification(res?.list || [])
                } else {
                    window.showToast("error", res?.error || "Something went wrong");
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            true
        );
    }, [deviceId, userId]);

    const readNotifications = useCallback(async () => {
        if (!deviceId || !userId) return;

        const payload = {
            deviceID: deviceId,
            userKey: userId,
            companyKey: companyId,
            role: loginObject?.role || 3
        };
        await handleApiCall(
            (config) => axios.post(urls.readNotification, payload, config),
            (response) => {
                const res = response.data;
                if (res.status === true) {

                } else {
                    window.showToast("error", res?.error || "Something went wrong");
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            true
        );
    }, [deviceId, userId]);

    const updateUserLanguage = useCallback(async () => {
        if (!deviceId || !userId || !selected) return;

        const payload = {
            deviceID: deviceId,
            userKey: userId,
            languageCode: selected
        };

        await handleApiCall(
            (config) => axios.post(urls.updateUserLanguage, payload, config),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                } else {
                    window.showToast("error", res?.error || "Something went wrong");
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            true
        );
    }, [deviceId, userId, selected]);

    const notificationOnOff = useCallback(
        async (status) => {
            if (!deviceId || !userId) return;
            const payload = {
                deviceID: deviceId,
                userKey: userId,
                companyKey: process.env.REACT_APP_COMPANY_ID,
                role: loginObject?.role || 3,
                status
            };

            try {
                const response = await handleApiCall(
                    (config) => axios.post(urls.notificationOnOff, payload, config),
                    (response) => response.data
                );
                const res = response?.data || response;
                if (res?.status === true) {
                    return true;
                } else {
                    window.showToast("error", res?.error || "Something went wrong");
                    return false;
                }
            } catch (err) {
                window.showToast("error", "Export failed");
                return false;
            }
        },
        [deviceId, userId]
    );

    useEffect(() => {
        window.loginWithGoogle = async (token) => {
            let deviceID = storage.get('DeviceId');
            const payload = { deviceID, token, companyKey: process.env.REACT_APP_COMPANY_ID, licence_type: licenseType, device_data: deviceInfo };

            try {
                const response = await handleApiCall(
                    () => axios.post(urls.googleLogin, payload),
                    (response) => response.data
                );
                const res = response?.data || response;

                if (res?.status === true) {
                    if (res?.msg) {
                        window.showToast('success', res?.msg);
                    }
                    const auth = res?.auth;
                    const next = res?.next;

                    if (auth && typeof auth === "object" && typeof auth.access_token === "string" && auth.access_token.trim() !== "") {
                        const decodeAccessToken = jwtDecode(auth.access_token);

                        storage.set('accessToken', auth.access_token);
                        storage.set('refreshToken', auth.refresh_token);
                        storage.set('tokenExpiry', decodeAccessToken?.exp);
                        storage.set('loginObj', decodeAccessToken);
                        storage.set('isLoggedIn', true);
                        let userId = decodeAccessToken?.userKey;
                        window.ReactNativeWebView?.postMessage(`userID|${userId}`);
                        startTokenRefreshTimer();
                    } else {
                        storage.remove('accessToken');
                        storage.remove('refreshToken');
                        storage.remove('tokenExpiry');
                        storage.remove('loginObj');
                        storage.set('isLoggedIn', false);
                        storage.set('verifiedEmail', res.email);
                    }

                    if (next === "dashboard") {
                        navigate(is4Life ? '/dashboard2' : '/dashboard');;
                    } else if (next === "signup") {
                        setEmail(res.email);
                        storage.set('verifiedEmail', res.email);
                        updateSignupData("email", email);
                        navigate('/create-account-1');
                    } else {
                        navigate('/login');
                    }

                } else {
                    window.showToast('error', res?.error || "Something went wrong");
                }

            } catch (error) {
                console.error("❌ Google login error:", error);
                window.showToast('error', error?.message || "Unexpected error occurred");
            }
        };

    }, []);

    useEffect(() => {
        window.loginWithApple = async (token) => {
            let deviceID = storage.get('DeviceId');
            const payload = { deviceID, token, companyKey: process.env.REACT_APP_COMPANY_ID, licence_type: licenseType, device_data: deviceInfo };

            try {
                const response = await handleApiCall(
                    () => axios.post(urls.appleLogin, payload),
                    (response) => response.data
                );
                const res = response?.data || response;

                if (res?.status === true) {
                    if (res?.msg) {
                        window.showToast('success', res?.msg);
                    }
                    const auth = res?.auth;
                    const next = res?.next;

                    if (auth && typeof auth === "object" && typeof auth.access_token === "string" && auth.access_token.trim() !== "") {
                        const decodeAccessToken = jwtDecode(auth.access_token);

                        storage.set('accessToken', auth.access_token);
                        storage.set('refreshToken', auth.refresh_token);
                        storage.set('tokenExpiry', decodeAccessToken?.exp);
                        storage.set('loginObj', decodeAccessToken);
                        storage.set('isLoggedIn', true);
                        let userId = decodeAccessToken?.userKey;
                        window.ReactNativeWebView?.postMessage(`userID|${userId}`);
                        startTokenRefreshTimer();
                    } else {
                        storage.remove('accessToken');
                        storage.remove('refreshToken');
                        storage.remove('tokenExpiry');
                        storage.remove('loginObj');
                        storage.set('isLoggedIn', false);
                        storage.set('verifiedEmail', res.email);
                    }

                    if (next === "dashboard") {
                        navigate(is4Life ? '/dashboard2' : '/dashboard');
                    } else if (next === "signup") {
                        setEmail(res.email);
                        storage.set('verifiedEmail', res.email);
                        updateSignupData("email", email);
                        navigate('/create-account-1');
                    } else {
                        navigate('/login');
                    }

                } else {
                    window.showToast('error', res?.error || "Something went wrong");
                }

            } catch (error) {
                console.error("❌ Google login error:", error);
                window.showToast('error', error?.message || "Unexpected error occurred");
            }
        };




        window.loginWith4life = async (token) => {
            const payload = {
                deviceID: deviceId || storage.get('DeviceId'),
                token: token,
                companyKey: process.env.REACT_APP_COMPANY_ID
            };
            try {
                const webhookRes = await axios.post(urls.webhookSignup, payload);
                const res = webhookRes?.data;
                if (res?.status === true) {
                    if (res?.msg) {
                        window.showToast('success', res?.msg);
                    }
                    const auth = res?.auth;
                    const next = res?.next;

                    if (auth && typeof auth === "object" && typeof auth.access_token === "string" && auth.access_token.trim() !== "") {
                        const decodeAccessToken = jwtDecode(auth.access_token);

                        storage.set('accessToken', auth.access_token);
                        storage.set('refreshToken', auth.refresh_token);
                        storage.set('tokenExpiry', decodeAccessToken?.exp);
                        storage.set('loginObj', decodeAccessToken);
                        storage.set('isLoggedIn', true);
                        let userId = decodeAccessToken?.userKey;
                        window.ReactNativeWebView?.postMessage(`userID|${userId}`);
                        startTokenRefreshTimer();
                    } else {
                        storage.remove('accessToken');
                        storage.remove('refreshToken');
                        storage.remove('tokenExpiry');
                        storage.remove('loginObj');
                        storage.set('isLoggedIn', false);
                        storage.set('verifiedEmail', res?.email);
                    }

                    if (next === "dashboard") {
                        navigate(is4Life ? '/dashboard2' : '/dashboard');
                    } else if (next === "signup") {
                        setEmail(res?.email);
                        storage.set('verifiedEmail', res?.email);
                        updateSignupData("email", res?.email || '');
                        updateSignupData("firstName", res?.first_name || '');
                        updateSignupData("lastName", res?.last_name || '');
                        navigate('/create-account-1');
                    } else {
                        navigate('/login');
                    }

                } else {
                    window.showToast('error', res?.error || "Something went wrong");
                }
            } catch (error) {
                console.error("❌ 4life login error:", error);
                window.showToast('error', error?.message || "Unexpected error occurred");
            }

        };

        console.log("✅ loginWith4life attached to window");

    }, []);

    const createCampaign = useCallback(
        async (campaignData) => {
            if (!deviceId || !userId || !companyId || !campaignData) return;
            const payload = {
                ...campaignData,
                deviceID: deviceId,
                companyKey: companyId,
                userKey: userId,
            }

            await handleApiCall(
                (config) => axios.post(urls.createCampaign, payload, config),
                (response) => {
                    const res = response.data;
                    if (res.status === true) {
                        window.showToast('success', res?.message);
                        navigate("/campaign-list");
                    } else {
                        window.showToast("error", res?.error || "Something went wrong");
                    }
                }
            );
        },
        [deviceId, userId, companyId]
    );

    const getCampaignList = useCallback(async (search = "") => {
        if (!deviceId || !userId || !companyId) return null;

        const payload = {
            deviceID: deviceId,
            companyKey: companyId,
            userKey: userId,
            role: loginObject?.role || 3,
            search: search || "",
        };

        if (search === "") {
            setIsLoading(true)
        }
        try {
            const freshToken = storage.get("accessToken");
            const config = {
                headers: { Authorization: `Bearer ${freshToken}` }
            };
            const response = await axios.post(urls.listCampaign, payload, config);

            const res = response.data;

            if (res.status !== true) {
                window.showToast(
                    "error",
                    res?.error || "Something went wrong"
                );
                return null;
            }

            return res;
        } catch (error) {
            window.showToast(
                "error",
                error?.response?.data?.error ||
                error.message ||
                "Something went wrong"
            );
            return null;
        } finally {
            setIsLoading(false)
        }
    }, [deviceId, companyId, userId]);

    const getCampaignDetails = useCallback(async (campaignCode) => {
        if (!deviceId || !userId || !companyId || !campaignCode) return null;

        const payload = {
            deviceID: deviceId,
            companyKey: companyId,
            userKey: userId,
            role: loginObject?.role || 3,
            campaignCode: campaignCode
        };

        try {
            const response = await handleApiCall(
                (config) => axios.post(urls.campaignDetails, payload, config),
                (response) => {
                    const res = response.data;

                    if (res.status !== true) {
                        window.showToast(
                            "error",
                            res?.error || "Something went wrong"
                        );
                    }
                },
                (error) => {
                    window.showToast(
                        "error",
                        error?.response?.data?.error ||
                        error.message ||
                        "Something went wrong"
                    );
                }
            );
            return response?.data || null;
        } catch (error) {
            return null;
        }
    }, [deviceId, companyId, userId]);

    const stopCampaign = useCallback(async (campaignCode) => {
        if (!deviceId || !userId || !companyId || !campaignCode) return null;

        const payload = {
            deviceID: deviceId,
            companyKey: companyId,
            userKey: userId,
            role: loginObject?.role || 3,
            campaignCode: campaignCode
        };

        try {
            const response = await handleApiCall(
                (config) => axios.post(urls.stopCampaign, payload, config),
                (response) => {
                    const res = response.data;
                    if (res.status === true) {
                        window.showToast(
                            "success",
                            "Campaign Expired!"
                        );
                    }

                    if (res.status !== true) {
                        window.showToast(
                            "error",
                            res?.error || "Something went wrong"
                        );
                    }
                },
                (error) => {
                    window.showToast(
                        "error",
                        error?.response?.data?.error ||
                        error.message ||
                        "Something went wrong"
                    );
                }
            );
            return response?.data || null;
        } catch (error) {
            return null;
        }
    }, [deviceId, companyId, userId]);

    const saveGuestUser = useCallback(
        async (details) => {
            if (!deviceId || !userId || !companyId) return;

            // let age = "";
            // if (details.dob) {
            //     const today = new Date();
            //     const dob = new Date(details.dob);
            //     age = today.getFullYear() - dob.getFullYear();
            //     const m = today.getMonth() - dob.getMonth();
            //     if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
            //         age--;
            //     }
            // }
            if (!details.age || details.age < 18) {
                window.showToast("error", "User must be at least 18 years old.");
                setMsgLoader(false);
                return;
            }
            let translatedLabels = storage.get('appLabels');


            const labels = {
                // Existing keys                                                                                                               
                pulse_wait: translatedLabels?.common?.pulse_wait,
                no_detect_face: translatedLabels?.common?.no_detect_face,
                no_detect_face_note: translatedLabels?.common?.no_detect_face_note,
                face_detect: translatedLabels?.common?.face_detect,
                scan_comment: translatedLabels?.common?.scan_comment,
                stop: translatedLabels?.common?.stop,
                adjust_face: translatedLabels?.common?.adjust_face,
                scan_stopped_note: translatedLabels?.common?.scan_stopped_note,
                scan_stopped: translatedLabels?.common?.scan_stopped,

                // Top Bar
                app_title: translatedLabels?.common?.app_title,
                front_camera_capture: translatedLabels?.common?.front_camera_capture,
                back_camera_capture: translatedLabels?.common?.back_camera_capture,

                // Oval Label
                position_face: translatedLabels?.common?.position_face,
                locking: translatedLabels?.common?.locking,
                hold_still: translatedLabels?.common?.hold_still,

                // Bottom Status Card
                readiness: translatedLabels?.common?.readiness,
                searching_for_face: translatedLabels?.common?.searching_for_face,
                stabilizing_frame: translatedLabels?.common?.stabilizing_frame,
                motion_detected: translatedLabels?.common?.motion_detected,
                capturing_signal: translatedLabels?.common?.capturing_signal,
                ready_to_begin: translatedLabels?.common?.ready_to_begin,
                locked: translatedLabels?.common?.locked,
                align: translatedLabels?.common?.align,

                // Progress
                of: translatedLabels?.common?.of,
                ready_to_scan: translatedLabels?.common?.ready_to_scan,

                // Buttons
                start_scan: translatedLabels?.common?.start_scan,
                hold_still_btn: translatedLabels?.common?.hold_still_btn,
                locking_face: translatedLabels?.common?.locking_face,
                look_at_camera: translatedLabels?.common?.look_at_camera,

                // Status Messages
                low_light: translatedLabels?.common?.low_light,
                too_bright: translatedLabels?.common?.too_bright,
                move_back: translatedLabels?.common?.move_back,
                move_closer: translatedLabels?.common?.move_closer,
                center_face: translatedLabels?.common?.center_face,
                look_at_camera_msg: translatedLabels?.common?.look_at_camera_msg,
                hold_still_lock: translatedLabels?.common?.hold_still_lock,
                hold_still_msg: translatedLabels?.common?.hold_still_msg,
                face_locked_start: translatedLabels?.common?.face_locked_start,
                hold_phone_eye_level: translatedLabels?.common?.hold_phone_eye_level,

                // Processing Overlay
                generating_health_report: translatedLabels?.common?.generating_health_report,
                analysing_vitals: translatedLabels?.common?.analysing_vitals,

                // Camera Permission Screen
                camera_scan_title: translatedLabels?.common?.camera_scan_title,
                camera_access_needed: translatedLabels?.common?.camera_access_needed,
                camera_permission_text: translatedLabels?.common?.camera_permission_text,
                allow_camera_access: translatedLabels?.common?.allow_camera_access,
                no_camera_device: translatedLabels?.common?.no_camera_device,
            };

            const payload = {
                firstName: details.firstName,
                lastName: details.lastName,
                email: details.email,
                deviceID: deviceId,
                parentUserKey: userId,
                guestUserKey: details.guestUserKey,
                companyKey: companyId,
                role: loginObject?.role || 3,
                gender: details.gender,
                weightUnit: details.weightUnit,
                weight: details.weight,
                heightUnit: details.heightUnit,
                waistUnit: details.waistUnit,
                waist_circumference: details.waist_circumference,
                height: details.height,
                smoking: details.smoking,
                dob: details.dob,
                diabetes: details.diabetes,
                hypertension: details.hypertension,
                race: details.race,
                cameraMode: details.cameraMode,
                age: details.age,
                labels: labels,
                servings: details.servings,
            };

            await handleApiCall(
                (config) => axios.post(urls.saveGuestUser, payload, config),
                (response) => {
                    const res = response.data;
                    if (res.status === true) {
                        let isPlanActive = storage.get('isPlanActive');
                        if (isPlanActive == true) {
                            storage.set("guestUserKey", res?.userData?.guestUserID);
                            storage.set("scanGuest", true);
                            console.log("=== GuestScan Payload ===");
                            console.log("Full Payload:", payload);
                            console.log("Camera Mode:", payload.cameraMode);
                            console.log("Race:", payload.race);
                            console.log("Gender:", payload.gender);
                            console.log("Age:", payload.age);
                            console.log("=======================");
                            console.log(payload);

                            window.ReactNativeWebView?.postMessage(`startScan|${JSON.stringify(payload)}`);
                        } else {
                            setMsgLoader(false);
                            navigate('/plan-expired');
                        }
                    } else {
                        window.showToast("error", res?.error || "Something went wrong");
                    }
                }
            );
        },
        [deviceId, userId, companyId, isPlanActive]
    );

    const getGuestUserList = useCallback(async (shouldNavigate = true) => {
        if (!deviceId || !userId || !companyId) return;

        const payload = {
            deviceID: deviceId,
            companyKey: companyId,
            userKey: userId,
            role: loginObject?.role || 3
        };

        await handleApiCall(
            (config) => axios.post(urls.getGuestUserList, payload, config),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    setGuestList(res.list || []);
                    if (!shouldNavigate) return true;

                    if (res.list && res.list.length > 0) {
                        navigate('/guest-scan');
                    } else {
                        navigate('/guest-scan');
                    }
                    return true;
                } else {
                    window.showToast("error", res?.error || "Something went wrong");
                    if (shouldNavigate) {
                        navigate('/guest-scan');
                    }
                    return false;
                }
            },
            (error) => {
                window.showToast("error", error?.response?.data?.error || error.message || "Something went wrong");
                if (shouldNavigate) {
                    navigate('/guest-scan');
                }
                return false;
            }
        );
    }, [deviceId, companyId, userId, navigate]);

    const getGuestUserDetails = useCallback(async (guestUserKey) => {
        if (!deviceId || !userId || !companyId || !guestUserKey) return;

        const payload = {
            deviceID: deviceId,
            companyKey: companyId,
            userKey: userId,
            guestUserKey: guestUserKey,
            role: loginObject?.role || 3
        };

        return await handleApiCall(
            (config) => axios.post(urls.getGuestUserDetails, payload, config),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    return res.detail;
                } else {
                    window.showToast("error", res?.error || "Something went wrong");
                    return null;
                }
            },
            (error) => {
                window.showToast("error", error?.response?.data?.error || error.message || "Something went wrong");
                return null;
            }
        );
    }, [deviceId, companyId, userId]);

    const deleteGuestUser = useCallback(async (guestUserKey) => {
        if (!deviceId || !userId || !guestUserKey) return;

        const payload = {
            deviceID: deviceId,
            userKey: userId,
            guestUserKey: guestUserKey,
            role: loginObject?.role || 3
        };

        const result = await handleApiCall(
            (config) => axios.post(urls.deleteGuestUser, payload, config),
            (response) => {
                const res = response?.data;
                if (res?.status === true) {
                    window.showToast("success", res.message || "Guest user deleted successfully");
                    return true;
                } else {
                    window.showToast("error", res?.error || "Something went wrong");
                    return false;
                }
            },
            (error) => {
                window.showToast("error", error?.response?.data?.error || error.message || "Something went wrong");
                return false;
            }
        );
        if (result) {
            await getGuestUserList(false);
        }
        return result;
    }, [deviceId, userId, getGuestUserList, loginObject?.role]);

    const getUserScanLimit = useCallback(async () => {
        if (!deviceId || !companyId || !userId) return;

        const payload = {
            deviceID: deviceId,
            companyKey: companyId,
            userKey: userId,
            role: loginObject?.role || 3
        };

        const cacheKey = `cachedScanLimit_${userId}`;
        const cached = storage.get(cacheKey);
        if (cached !== null && cached !== undefined) {
            setScanLimit(cached);
        }

        try {
            const freshToken = storage.get('accessToken');
            const response = await axios.post(urls.getScanLimit, payload, {
                headers: freshToken ? { Authorization: `Bearer ${freshToken}` } : {},
            });
            const res = response?.data;
            if (res?.status === true) {
                setScanLimit(res?.remain_status);
                storage.set(cacheKey, res?.remain_status);
            } else if (cached === null || cached === undefined) {
                window.showToast("error", res?.error || "Something went wrong");
            }
        } catch (err) {
            if (cached === null || cached === undefined) {
                window.showToast(
                    'error',
                    err?.response?.data?.error || err.message || 'Something went wrong'
                );
            }
        }
    }, [deviceId, companyId, userId, loginObject]);

    const updateUserServings = useCallback(async (serving) => {
        if (!deviceId || !companyId || !userId) return;

        const payload = {
            deviceID: deviceId,
            companyKey: companyId,
            userKey: userId,
            role: loginObject?.role || 3,
            fruits: serving.fruits,
            vegetables: serving.vegetables,
            grains: serving.grains,
            sugaryfoods: serving.sugaryfoods,
            redmeat: serving.redmeat,
            fish: serving.fish,
            activity: serving.activity
        };

        await handleApiCall(
            (config) => axios.post(urls.updateServings, payload, config),
            (response) => {
                const res = response.data;
                if (res.status === true) {
                    window.showToast('success', res.message);
                } else {
                    window.showToast("error", res?.error || "Something went wrong");
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            true
        );
    }, [deviceId, companyId, userId]);


    const fourLifeUserLogin = useCallback(async () => {
        if (!deviceId) return;

        const payload = {
            deviceID: deviceId,
            company_id: process.env.REACT_APP_COMPANY_ID,
            email: fourLifeuserData.userName,
            password: fourLifeuserData.password,
            licence_type: licenseType,
        };

        if (!fourLifeuserData.userName) {
            window.showToast("error", "Please enter your username.");
            return;
        }

        if (!fourLifeuserData.password) {
            window.showToast("error", "Please enter your password.");
            return;
        }
        await handleApiCall(
            () => axios.post(urls.userLogin, payload),
            (response) => {
                const res = response.data;
                if (res?.status === true) {
                    if (res?.next_screen == "signup") {
                        navigate('/create-account-1');
                        return;
                    }
                    storage.set('isLoggedIn', true)
                    const decodeAccessToken = jwtDecode(res?.token?.access_token);

                    storage.set('accessToken', res?.token?.access_token);
                    storage.set('refreshToken', res?.token?.refresh_token);
                    storage.set('tokenExpiry', decodeAccessToken?.exp);
                    startTokenRefreshTimer();
                    storage.set('loginObj', decodeAccessToken)
                    storage.remove('verifiedEmail');
                    let navigatetodashboard = is4Life ? '/dashboard2' : '/dashboard';
                    navigate(navigatetodashboard)
                    storage.set('UserModule', 'Login')
                    let userId = decodeAccessToken?.userKey;
                    window.ReactNativeWebView?.postMessage(`userID|${userId}`);
                    updateUserData('password', '')
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                    updateUserData('password', '')
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            false
        );
    }, [deviceId, companyId, fourLifeuserData]);


    const getFourLifeScanHistory = useCallback(async () => {
        if (!deviceId) return;

        const payload = {
            deviceID: deviceId,
            companyKey: process.env.REACT_APP_COMPANY_ID,
            userKey: userId,
            role: loginObject?.role || 3,
        };


        await handleApiCall(
            (config) => axios.post(urls.getFourLifeScanHistory, payload, config, { silent: true }),
            (response) => {
                const res = response.data;
                if (res?.status === true) {
                    setFourLifeScanHistory(res?.list || [])
                } else {
                    window.showToast('error', res.error || 'Something went wrong');
                    updateUserData('password', '')
                }
            },
            (error) => {
                window.showToast('error', error?.response?.data?.error || error.message || 'Something went wrong');
            },
            true
        );
    }, [deviceId, companyId, fourLifeuserData]);

    useEffect(() => {
        updateUserLanguage();
    }, [selected, updateUserLanguage]);

    if (msgLoader) {
        return <Loader />
    }
    return (
        <GlobalContext.Provider
            value={{
                isLoading,
                showPasswords,
                togglePassword,
                updateUserData,
                userData,
                checkUserRegistration,
                email,
                loginByPassword,
                handlenavigateToEmail,
                sendEmailOTP,
                verifyOTP,
                setEmail,
                doLogout,
                resetPassword,
                resendEmailOTP,
                timer,
                resendDisabled,
                updateSignupData,
                createAccountScreenOne,
                createAccountScreenTwo,
                createAccountScreenThree,
                createAccountScreenFour,
                translatedLabels,
                setSelected,
                selected,
                setIsManualChange,
                translateData,
                signupData,
                completeSignup,
                setSignupData,
                getUserDetails,
                userDetails,
                updateUserDetails,
                isVerified,
                setIsVerified,
                deleteUserAcc,
                handleChangePassword,
                getFaqList,
                faqList,
                uploadCropImg,
                selectedBillType,
                setSelectedBillype,
                getLanguageList,
                languages,
                logoUrl,
                headerLogoUrl,
                uploadDocument,
                documentData,
                setDocumentData,
                getDocumentList,
                uploadedFiles,
                getTermsConditions,
                documentContent,
                getPrivacypolicy,
                getScanDetails,
                scanDetails,
                getArticlesList,
                articlesList,
                pagination,
                getArticleDetailsByID,
                articleDetails,
                getScanHistory,
                scanHistory,
                deletedocument,
                getWellnessCat,
                wellnessCat,
                listBioMarker,
                bioMarker,
                editUserDetails,
                tempScanDetails,
                setMsgLoader,
                showExportModal,
                setShowExportModal,
                userEmail,
                showCalendar,
                setShowCalendar,
                calendarRef,
                exportScanDetails,
                globalUserEmail,
                setGlobalUserEmail,
                getHistoryDates,
                historyDates,
                setSearch,
                search,
                resetArticlesSearch,
                wellnessLabel,
                wellnessLabelNormal,
                getNotificationList,
                notification,
                readNotifications,
                hasNotification,
                setHasNotification,
                isNotificationReceived,
                setIsNotificationReceived,
                handleNotificationClick,
                getTimeZone,
                timeZone,
                notificationOnOff,
                setNotificationsEnabled,
                notificationsEnabled,
                handleDeletAccount,
                showOTPSection,
                setShowOTPSection,
                getuserDetails,
                setUserDatav2,
                userDatav2,
                verifyAccessCode,
                isThankYou,
                createCampaign,
                getCampaignList,
                getCampaignDetails,
                stopCampaign,
                saveGuestUser,
                getGuestUserList,
                getGuestUserDetails,
                deleteGuestUser,
                guestList,
                getUserScanLimit,
                scanLimit,
                setScanLimit,
                is4Life,
                servings,
                updateUserServings,
                setFourLifeUserData,
                fourLifeuserData,
                fourLifeUserLogin,
                fourLifeSSOLogin,
                products,
                dynamicTypes,
                getRecProductList,
                fullProducts,
                redirection,
                fourLifeVerifyOTP,
                fourLifeEmailOTP,
                fourLiferesendOTP,
                verifiedsecEmail,
                deleteGuestUser,
                getFourLifeScanHistory,
                fourLifeScanHistory,
            }}
        >
            {isLoading && (
                <Loader />
            )}
            {children}
        </GlobalContext.Provider>
    );
};
